/* ===== Aquisição e ADS (Liquid 2) ===== */
(function(){
  "use strict";
  var MC_API   = "https://script.google.com/macros/s/AKfycbx4cDDEvk8YNl8_ObUtTyXL44ASWsO24yYbN4RUmPpSekq3eGhyuZGRQ4ieg8_DBoUq/exec";
  var MC_TOKEN = "mc_cc6f126b6aaf46bfa553068c22727813";
  var root = document.getElementById("mc-ac");
  var $ = function(s){ return root.querySelector(s); };

  /* ── JSONP call ── */
  function call(p){ return new Promise(function(res,rej){ var cb="mc_cb_"+Math.random().toString(36).slice(2),s=document.createElement("script"),to=setTimeout(function(){cl();rej(new Error("Tempo esgotado"));},60000); function cl(){clearTimeout(to);try{delete window[cb];}catch(e){window[cb]=undefined;}if(s.parentNode)s.parentNode.removeChild(s);} window[cb]=function(d){cl();res(d);}; var qs=Object.keys(p).map(function(k){return encodeURIComponent(k)+"="+encodeURIComponent(p[k]);}).join("&"); s.src=MC_API+"?key="+encodeURIComponent(MC_TOKEN)+"&callback="+cb+(qs?("&"+qs):""); s.onerror=function(){cl();rej(new Error("Falha de rede"));}; document.head.appendChild(s); }); }

  /* ── verifica saldo Meta Ads ── */
  (function checkMetaBalance(){
    call({resource:"meta_balance"}).then(function(r){
      var el = document.getElementById("mc-meta-alert");
      if(!el) return;
      if(r && r.error){
        el.textContent = "⚠ Meta Ads: erro ao verificar saldo — "+String(r.error).slice(0,120);
        el.style.display = "block";
        return;
      }
      if(r && r.ok){
        var bal = Number(r.balance)||0;
        if(bal < 100){
          el.textContent = "⚠ Saldo Meta Ads baixo: R$ "+bal.toLocaleString("pt-BR",{minimumFractionDigits:2,maximumFractionDigits:2})+" — recarregue o crédito para não interromper campanhas";
          el.style.display = "block";
        }
      } else if(r && !r.ok){
        el.textContent = "⚠ Meta Ads: saldo indisponível — "+String(r.error||"conta não suporta consulta de saldo").slice(0,120);
        el.style.display = "block";
      }
    }).catch(function(){});
  })();

  /* ── formatters ── */
  var BRL = function(n){ return (Number(n)||0).toLocaleString("pt-BR",{style:"currency",currency:"BRL"}); };
  var PCT = function(n){ return ((Number(n)||0)*100).toFixed(1).replace(".",",")+"%"; };
  var NUM = function(n){ return (Number(n)||0).toLocaleString("pt-BR"); };
  var esc = function(s){ return String(s==null?"":s).replace(/[&<>"]/g,function(c){return({"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"})[c];}); };
  var dash = function(v,fmt){ return (!v||v<=0)?"-":fmt(v); };

  /* ── modal de confirmação da própria dashboard (centralizado) ── */
  function mcConfirm(message, okLabel){
    return new Promise(function(resolve){
      var ov=document.createElement("div");
      ov.className="mc-modal-ov";
      ov.innerHTML='<div class="mc-modal" role="dialog" aria-modal="true">'+
        '<div class="mc-modal-msg">'+esc(message)+'</div>'+
        '<div class="mc-modal-actions">'+
          '<button type="button" class="mc-modal-btn mc-modal-cancel">Cancelar</button>'+
          '<button type="button" class="mc-modal-btn mc-modal-ok">'+esc(okLabel||"Confirmar")+'</button>'+
        '</div></div>';
      document.body.appendChild(ov);
      function done(v){ document.removeEventListener("keydown",onKey); if(ov.parentNode) ov.parentNode.removeChild(ov); resolve(v); }
      function onKey(e){ if(e.key==="Escape") done(false); else if(e.key==="Enter") done(true); }
      ov.querySelector(".mc-modal-ok").addEventListener("click",function(){ done(true); });
      ov.querySelector(".mc-modal-cancel").addEventListener("click",function(){ done(false); });
      ov.addEventListener("mousedown",function(e){ if(e.target===ov) done(false); });
      document.addEventListener("keydown",onKey);
      setTimeout(function(){ var b=ov.querySelector(".mc-modal-ok"); if(b) b.focus(); },20);
    });
  }
  /* ── modal de entrada de texto (mesmo design) — resolve com a string ou null ── */
  function mcPrompt(message, placeholder, defVal, okLabel){
    return new Promise(function(resolve){
      var ov=document.createElement("div");
      ov.className="mc-modal-ov";
      ov.innerHTML='<div class="mc-modal" role="dialog" aria-modal="true">'+
        '<div class="mc-modal-msg">'+esc(message)+'</div>'+
        '<input type="text" class="mc-modal-input" placeholder="'+esc(placeholder||"")+'" value="'+esc(defVal||"")+'">'+
        '<div class="mc-modal-actions">'+
          '<button type="button" class="mc-modal-btn mc-modal-cancel">Cancelar</button>'+
          '<button type="button" class="mc-modal-btn mc-modal-ok">'+esc(okLabel||"Salvar")+'</button>'+
        '</div></div>';
      document.body.appendChild(ov);
      var inp=ov.querySelector(".mc-modal-input");
      function done(v){ document.removeEventListener("keydown",onKey); if(ov.parentNode) ov.parentNode.removeChild(ov); resolve(v); }
      function ok(){ var v=String(inp.value||"").trim(); done(v?v:null); }
      function onKey(e){ if(e.key==="Escape") done(null); else if(e.key==="Enter"){ e.preventDefault(); ok(); } }
      ov.querySelector(".mc-modal-ok").addEventListener("click",ok);
      ov.querySelector(".mc-modal-cancel").addEventListener("click",function(){ done(null); });
      ov.addEventListener("mousedown",function(e){ if(e.target===ov) done(null); });
      document.addEventListener("keydown",onKey);
      setTimeout(function(){ inp.focus(); inp.select(); },20);
    });
  }

  /* ── state ── */
  var ents=[], best=[], metas={}, media={}, kpiPrev=null, cancelados={count:0,valor:0,cancelado_count:0,cancelado_valor:0,naopago_count:0,naopago_valor:0}, custosTrafico={}, margemOp={}, fp=null, dateRange="30d", obj="all";
  var sel={campaign:{},adset:{},ad:{}}, bestPage=0, BEST_PER=6, bestPages=1, npDedTotal=0;
  var tblLpvRate=null; // taxa média de visual. da página dos itens ATIVOS da lista de campanhas (item do funil)
  var sortKey="valor_usado", sortDir=-1, search="", hideInactive=false;
  var loadSeq=0, tblSeq=0; // tokens de concorrência: ignora respostas antigas fora de ordem

  /* ── imposto Meta 12,5% ── */
  var META_TAX = 1.125;
  // Converte range nomeado para label legível
  function rangeLabel(r){
    if(!r||r==='30d') return 'Últimos 30 dias';
    if(r==='hoje') return 'Hoje';
    if(r==='hoje_ontem') return 'Hoje + Ontem';
    if(r==='7d') return 'Últimos 7 dias';
    if(r==='mes') return 'Este mês';
    if(r==='ano') return 'Este ano';
    if(r==='max') return 'Máximo';
    if(r.indexOf('~')>0){ var p=r.split('~'); return p[0]+' a '+p[1]; }
    return r;
  }
  // Nº de dias do período selecionado (para o mínimo de 3 dias das métricas)
  function rangeDays(){
    var r=dateRange;
    if(r==='hoje') return 1;
    if(r==='hoje_ontem') return 2;
    if(r==='7d') return 7;
    if(r==='30d') return 30;
    if(r==='mes') return new Date().getDate();
    if(r==='ano'||r==='max') return 365;
    if(r&&r.indexOf('~')>0){ var p=r.split('~'); var d1=new Date(p[0]),d2=new Date(p[1]); return Math.round((d2-d1)/86400000)+1; }
    return 30;
  }
  // Backend (parseRange_/periodWindow_) entende 'hoje_ontem' e 'ano' nativamente.
  // Não traduzimos mais para datas via toISOString() porque o UTC empurrava a
  // janela um dia pra frente para quem está em fuso negativo (ex: Brasil UTC-3).
  function apiRange(r){ return r; }
  // Aplica imposto de 12,5% nos dados deep de anúncios
  function applyMetaTax(d){
    var TAX=META_TAX;
    // spend nos ents (métricas derivadas se ajustam automaticamente no render)
    (d.entidades||[]).forEach(function(x){ if(x.spend) x.spend*=TAX; });
    // campos pré-computados em best
    var BFIELDS=['spend','cpa','custo_cart','custo_chk','custo_lpv','d_spend','d_cart','d_chk','d_cpa','d_lpv','m_cpa_ideal','m_cpa_max','m_cart_ideal','m_cart_max','m_chk_ideal','m_chk_max'];
    (d.melhores||[]).forEach(function(x){
      BFIELDS.forEach(function(k){ if(x[k]) x[k]*=TAX; });
      if(x.roas) x.roas/=TAX; // roas = receita/spend; spend aumentou
    });
    // metas
    var m=d.metas||{};
    ['cpa_ideal','cpa_max','cart_ideal','cart_max','chk_ideal','chk_max'].forEach(function(k){ if(m[k]) m[k]*=TAX; });
    // médias do tooltip
    var med=d.media||{};
    ['cpa','cart','chk','lpv','spend'].forEach(function(k){ if(med[k]) med[k]*=TAX; });
    // período anterior (para deltas)
    var prev=d.kpi_prev; if(prev&&prev.spend) prev.spend*=TAX;
  }
  // Aplica imposto nos dados de tabela drill-down
  function applyTableTax(rows){
    var TAX=META_TAX;
    var TFIELDS=['valor_usado','custo_resultado','custo_cart','custo_chk','custo_compra','custo_lpv','cpm','cpc_link'];
    rows.forEach(function(r){
      TFIELDS.forEach(function(k){ if(r[k]) r[k]=(Number(r[k])||0)*TAX; });
      if(r.roas) r.roas/=TAX;
    });
  }

  /* ── selection helpers ── */
  function selCount(){ return Object.keys(sel.campaign).length+Object.keys(sel.adset).length+Object.keys(sel.ad).length; }
  /* prioriza o nível MAIS PROFUNDO selecionado: anúncios > conjuntos > campanhas.
     assim, se campanhas e conjuntos estiverem marcados juntos, vale só os conjuntos (e ads têm prioridade máxima).
     KPIs, chips, funis e gráficos usam isso pois todos passam por selParams(). */
  function selParams(){
    var c=Object.keys(sel.campaign).join(','), a=Object.keys(sel.adset).join(','), d=Object.keys(sel.ad).join(',');
    if(d) return {camp_ids:'',adset_ids:'',ad_ids:d};
    if(a) return {camp_ids:'',adset_ids:a,ad_ids:''};
    return {camp_ids:c,adset_ids:'',ad_ids:''};
  }
  function updateSelInfo(){ var n=selCount(),info=$("#adp-sel-info"),clr=$("#adp-sel-clear"); if(info) info.textContent=n?(n+' selecionado(s)'):''; if(clr) clr.style.display=n?'':'none'; }
  var _selT; function selChanged(){ updateSelInfo(); clearTimeout(_selT); _selT=setTimeout(function(){ bestPage=0; load(); },350); }
  function sum(L,k){ var s=0; L.forEach(function(x){s+=Number(x[k])||0;}); return s; }

  /* ── KPI helpers ── */
  function setVal(k,v){ var el=$('#adp-kpis .mc-kpi[data-k="'+k+'"] .mc-kpi-val'); if(el) el.textContent=v; }
  /* estado de carregamento: R$ + números trocando aleatoriamente (scramble), pulsando em cinza */
  var ACQ_KPI_KEYS=['faturamento','custo','saldo','ticket','cpa','roas','roi'];
  var _scrambleT=null;
  function acqRandMoney(){ var n=Math.floor(Math.random()*90000)+100; return 'R$ '+n.toLocaleString('pt-BR'); }
  function acqScrambleTick(){ Array.prototype.forEach.call(root.querySelectorAll('.acq-scramble'),function(el){ el.textContent='R$ 0.000'; }); }
  function acqStartScramble(){ acqScrambleTick(); }   // valor-fantasma estático (só a pulsação via CSS, sem randomizar)
  function acqStopScramble(){ if(_scrambleT){ clearInterval(_scrambleT); _scrambleT=null; } }
  /* chips-fantasma enquanto carrega (mesma estrutura, valor em scramble) */
  function acqChipsLoading(){
    var ch=$('#ac-chips'); if(!ch) return;
    var defs=[['Ticket Médio',ICN.ticket],['Custo por resultado',ICN.cpa],['Custo por carrinho',ICN.cart],['Custo por checkout',ICN.chk]];
    ch.innerHTML='<div class="mc-chips3-wrap"><div class="mc-chips3">'+defs.map(function(d){
      return '<div class="mc-chip3"><div class="chip3-icon">'+ic(d[1])+'</div><div class="chip3-nm">'+esc(d[0])+'</div><div class="chip3-val acq-scramble">R$ 0</div></div>';
    }).join('')+'</div></div>';
  }
  function acqSetLoading(on){
    var box=$('#adp-kpis'); if(box) box.classList.toggle('is-loading',!!on);
    var fn=$('#adp-funnel'); if(fn) fn.classList.toggle('is-loading',!!on);
    if(on){
      // marca os valores dos KPIs para scramble
      ACQ_KPI_KEYS.forEach(function(k){ var el=$('#adp-kpis .mc-kpi[data-k="'+k+'"] .mc-kpi-val'); if(el){ el.classList.add('acq-scramble'); el.style.color=''; } });
      acqChipsLoading();
      acqStartScramble();
    } else {
      acqStopScramble();
      Array.prototype.forEach.call(root.querySelectorAll('.acq-scramble'),function(el){ el.classList.remove('acq-scramble'); });
    }
  }
  function setDelta(k, curr, prev, lowerBetter, ttl){
    var el=$('#adp-kpis .mc-kpi[data-k="'+k+'"] .mc-kpi-delta'); if(!el) return;
    if(!prev||!curr){ el.innerHTML=''; return; }
    var delta=(curr-prev)/Math.abs(prev);
    if(Math.abs(delta)<0.001){ el.innerHTML=''; return; }
    var up=delta>0;
    var good=lowerBetter===null?null:(lowerBetter?!up:up);
    var cls=good===null?'kpi-delta-neu':(good?'kpi-delta-good':'kpi-delta-bad');
    var pct=(delta*100).toFixed(1).replace('.',',')+"%";
    var ta=ttl?' title="'+esc(ttl)+'"':'';
    el.innerHTML='<span class="kpi-delta '+cls+'"'+ta+'>'+(up?'▲':'▼')+' '+pct+'</span>';
  }
  function prevPeriodLabel(){
    if(!kpiPrev) return '';
    if(dateRange==='hoje') return 'vs ontem';
    if(dateRange==='hoje_ontem') return 'vs 2 dias anteriores';
    if(dateRange==='7d') return 'vs 7 dias anteriores';
    if(dateRange==='30d') return 'vs 30 dias anteriores';
    if(dateRange==='mes') return 'vs mês anterior';
    if(dateRange==='ano') return 'vs ano anterior';
    if(dateRange && dateRange.indexOf('~')>0){
      var pts=dateRange.split('~'),d1=new Date(pts[0]),d2=new Date(pts[1]);
      var days=Math.round((d2-d1)/86400000)+1;
      var pTo=new Date(d1.getTime()-86400000),pFr=new Date(pTo.getTime()-(days-1)*86400000);
      function fd(d){ return d.getDate()+'/'+(d.getMonth()+1); }
      return 'vs '+fd(pFr)+' – '+fd(pTo);
    }
    return 'vs período anterior';
  }
  function stCls(cost,ideal,max){ if(!cost)return''; if(ideal&&cost<=ideal)return'is-good'; if(max&&cost<=max)return''; return'is-bad'; }
  function setKpiTip(k,o){
    var el=$('#adp-kpis .mc-kpi[data-k="'+k+'"] .mc-kpi-val'); if(!el) return;
    el.setAttribute('data-tt','1'); el.setAttribute('data-name',o.name||k);
    el.setAttribute('data-val',o.val||0); el.setAttribute('data-fmt',o.fmt||'brl');
    el.setAttribute('data-media',o.media||0); el.setAttribute('data-ideal',o.ideal||0);
    el.setAttribute('data-max',o.max||0); el.setAttribute('data-lower',o.lower||'');
    if(o.detail) el.setAttribute('data-detail',o.detail); else el.removeAttribute('data-detail');
    el.classList.add('tt');
  }

  /* ── svg icon helper ── */
  function ic(p){ return '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square">'+p+'</svg>'; }
  var ICN={
    ticket:'<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line>',
    cpa:  '<circle cx="12" cy="12" r="9"></circle><circle cx="12" cy="12" r="3"></circle>',
    cart: '<circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.6 13H19l2-9H6"></path>',
    chk:  '<path d="M20 6L9 17l-5-5"></path>',
    prop: '<path d="M3 3v18h18"></path><path d="M7 14l3-3 3 3 4-5"></path>'
  };

  /* ── render KPIs ── */
  function renderKpis(L){
    var spend=sum(L,'spend'),reach=sum(L,'reach'),impr=sum(L,'impressions');
    var res=sum(L,'resultados'), conv=sum(L,'conversao_valor');
    /* resLiq: Meta count minus order-level cancelleds AND campaign-matched não pagos */
    var resLiq=Math.max(0,res-(cancelados.count||0)-npDedTotal);
    var fatBruto=conv;                             // total bruto Meta (p/ tooltip)
    var fatSemCanc=conv-(cancelados.cancelado_valor||0); // sem cancelados
    var naoPagoTraf=cancelados.naopago_valor||0;   // não pagos com origem tráfego
    var fat=fatSemCanc-naoPagoTraf;                // faturamento líquido (sem cancelados e não pagos tráfego)
    // Saldo real: usa margem operacional média (todos os pedidos pagos do período)
    // aplicada à receita Meta. Fallback: tráfego-tagged → receita bruta Meta.
    var moPct  = Number(margemOp.pct)     || 0; // ex: 0.72 = lucro / faturamento
    var moCuPct= Number(margemOp.custo_pct)|| 0;
    var moFat  = Number(margemOp.fat)     || 0;
    var moLuc  = Number(margemOp.lucro)   || 0;
    var hasMargem = moPct > 0 && moFat > 0;
    // lucro estimado dos pedidos tráfego = conv_meta × margem_op_%
    var lucroEstimado = hasMargem ? fat * moPct : (Number(custosTrafico.lucro_op)||0);
    var saldo = lucroEstimado ? lucroEstimado - spend : fat - spend;
    var cpa=resLiq?spend/resLiq:0, cpm=impr?spend/impr*1000:0;
    var roas=spend?fat/spend:0, roi=fat?saldo/fat:0;
    var freq=reach?impr/reach:0;
    var fmtX=function(x){return x.toFixed(2).replace(".",",")+"x";};
    var fmtD=function(x){return x.toFixed(2).replace(".",",");};
    var ticket=resLiq?fat/resLiq:0;
    setVal("faturamento",dash(fat,   BRL));
    setVal("ticket",     dash(ticket,BRL));
    setVal("custo",      dash(spend, BRL));
    setVal("saldo",      saldo!==0?BRL(saldo):"-");
    setVal("cpa",        dash(cpa,   BRL));
    setVal("cpm",        dash(cpm,   BRL));
    setVal("roas",       dash(roas,  fmtX));
    setVal("roi",        dash(roi,   PCT));
    // Saldo: verde se positivo, vermelho se negativo
    (function(){
      var el=$('#adp-kpis .mc-kpi[data-k="saldo"] .mc-kpi-val');
      if(el) el.style.color = saldo>0?'var(--good)':saldo<0?'var(--bad)':'';
    })();
    // ROI em amarelo (destaque de retorno sobre investimento)
    (function(){
      var el=$('#adp-kpis .mc-kpi[data-k="roi"] .mc-kpi-val');
      if(el) el.style.color='var(--acc)';
    })();
    /* tips */
    var fatDetail='Total bruto Meta: '+BRL(fatBruto);
    if(cancelados.cancelado_count) fatDetail+='\nCancelados (tráfego): −'+cancelados.cancelado_count+' ped. ('+BRL(cancelados.cancelado_valor||0)+')';
    if(cancelados.naopago_count) fatDetail+='\nNão pagos (tráfego): −'+cancelados.naopago_count+' ped. ('+BRL(naoPagoTraf)+') [excluídos]';
    fatDetail+='\n────────\nLíquido: '+BRL(fat);
    setKpiTip('faturamento',{name:'Faturamento líquido',val:fat,fmt:'brl',detail:fatDetail});
    var cpaDetail='Resultados líq.: '+NUM(resLiq);
    if(cancelados.count) cpaDetail+=' — ded.: '+cancelados.count+' ('+cancelados.cancelado_count+' canc. + '+cancelados.naopago_count+' n.pago)';
    setKpiTip('cpa',{name:'Custo/resultado',val:cpa,fmt:'brl',lower:'1',detail:cpaDetail});
    // Custo em ads: sem tooltip
    (function(){ var el=$('#adp-kpis .mc-kpi[data-k="custo"] .mc-kpi-val'); if(el){ el.removeAttribute('data-tt'); el.classList.remove('tt'); } })();
    // Tooltip saldo
    if(hasMargem){
      var custEstimado = fat * moCuPct;
      var saldoDetail =
        'Receita Meta atribuída: '+BRL(fat)+
        '\nCusto op. estimado ('+PCT(moCuPct)+'): -'+BRL(custEstimado)+
        '\nLucro estimado ('+PCT(moPct)+'): '+BRL(lucroEstimado)+
        '\nAds (-12,5% imposto): -'+BRL(spend)+
        '\n─────'+
        '\nBase: '+NUM(margemOp.n||0)+' pedidos / fat. '+BRL(moFat);
      setKpiTip('saldo',{name:'Saldo real estimado',val:saldo,fmt:'brl',detail:saldoDetail});
    } else if(Number(custosTrafico.custo_total)>0){
      var lucroOp2 = Number(custosTrafico.lucro_op)||0;
      var saldoDetail2='Faturamento (tráfego): '+BRL(custosTrafico.fat||0)+
        '\nProdutos: -'+BRL(custosTrafico.cogs||0)+
        '\nEmbalagem: -'+BRL(custosTrafico.embalagem||0)+
        '\nGateway: -'+BRL(custosTrafico.taxa||0)+
        (custosTrafico.frete>0?'\nFrete: -'+BRL(custosTrafico.frete):'')+
        '\nLucro op.: '+BRL(lucroOp2)+
        '\nAds: -'+BRL(spend);
      setKpiTip('saldo',{name:'Saldo real',val:saldo,fmt:'brl',detail:saldoDetail2});
    }
    /* deltas vs período anterior */
    if(kpiPrev){
      var pS=kpiPrev.spend||0,pI=kpiPrev.impressions||0,pRc=kpiPrev.reach||0;
      var pR=kpiPrev.resultados||0,pV=kpiPrev.conversao_valor||0;
      var pFat=pV; var pSaldo=pFat-pS;
      var pCpa=pR?pS/pR:0,pCpm=pI?pS/pI*1000:0;
      var pRoas=pS?pFat/pS:0,pRoi=pS?(pFat-pS)/pS:0;
      var pFreq=pRc?pI/pRc:0;
      var lbl=prevPeriodLabel();
      setDelta("faturamento",fat,   pFat,  false, lbl);
      setDelta("custo",      spend, pS,    null,  lbl);
      setDelta("saldo",      saldo, pSaldo,false, lbl);
      // Delta do saldo em amarelo
      (function(){ var el=$('#adp-kpis .mc-kpi[data-k="saldo"] .kpi-delta'); if(el) el.style.color='var(--acc)'; })();
      setDelta("cpa",        cpa,   pCpa,  true,  lbl);
      setDelta("cpm",        cpm,   pCpm,  true,  lbl);
      setDelta("roas",       roas,  pRoas, false, lbl);
      setDelta("roi",        roi,   pRoi,  false, lbl);
    }
  }

  /* ── placeholder do funil (durante carregamento) ── */
  function renderFunnelPlaceholder(){
    var steps=['Visual. da página','Carrinho','Checkout','Pedidos','Pedidos pagos'];
    var ph=steps.map(function(nm){
      return '<div class="mc-vbar">'+
        '<span class="mc-vv acq-scramble">R$ 0</span>'+
        '<div class="mc-vcol"><div class="mc-vfill" style="height:2%"></div></div>'+
        '<span class="mc-vlab">'+nm+'</span>'+
        '<span class="mc-vpct acq-scramble">R$ 0</span>'+
        '</div>';
    }).join('');
    $("#adp-funnel").innerHTML='<div class="mc-vbars mc-acq-vbars mc-loading">'+ph+'</div>';
  }
  /* ── placeholder do gráfico de métricas (linha/área falsa pulsando, igual ao do funil) ── */
  function renderChartPlaceholder(){
    var box=$("#adp-funnel"); if(!box) return;
    var W=580,H=112,padL=40,padR=40,padT=16,plotH=78,baseY=padT+plotH;
    var cw=box.clientWidth||760, hpx=Math.round(cw*H/W);
    var pts=[[padL,baseY-18],[padL+90,baseY-42],[padL+180,baseY-28],[padL+270,baseY-58],[padL+360,baseY-38],[padL+450,baseY-66],[W-padR,baseY-48]];
    var line=_smoothPath(pts), area=line+' L '+(W-padR)+' '+baseY+' L '+padL+' '+baseY+' Z';
    var grid=''; for(var g=0;g<=4;g++){ var gy=baseY-plotH*g/4; grid+='<line x1="'+padL+'" y1="'+gy+'" x2="'+(W-padR)+'" y2="'+gy+'" stroke="#1a1a1a" stroke-width="0.5" stroke-dasharray="1.4 1.4"/>'; }
    box.innerHTML='<div class="mc-chart-ph" style="width:100%;padding:6px 0 2px"><svg viewBox="0 0 '+W+' '+H+'" preserveAspectRatio="none" style="width:100%;height:'+hpx+'px;display:block">'
      +'<defs><linearGradient id="phArea" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#3a3a3a" stop-opacity="0.45"/><stop offset="1" stop-color="#3a3a3a" stop-opacity="0.02"/></linearGradient></defs>'
      +grid+'<path d="'+area+'" fill="url(#phArea)"/><path d="'+line+'" fill="none" stroke="#3a3a3a" stroke-width="0.9" stroke-linejoin="round" stroke-linecap="round"/></svg></div>';
    var el=$("#adp-funnel-labels"); if(el) el.innerHTML='';
  }

  /* ── render funil vertical (estilo GA4 / dashboard) ── */
  function renderFunnel(){
    var L=curEnts();
    var spend=sum(L,'spend'),lpv=sum(L,'lpv');
    var cart=sum(L,'carrinho'),chk=sum(L,'checkout'),res=sum(L,'resultados');
    // Pedidos pagos = pedidos (compras Meta) menos os não pagos com origem tráfego
    var naoPagos=Number(cancelados.naopago_count)||0;
    var pagos=Math.max(0,res-naoPagos);
    var custoLpv=lpv?spend/lpv:0, custoCart=cart?spend/cart:0;
    var custoChk=chk?spend/chk:0, cpa=res?spend/res:0, cpaPago=pagos?spend/pagos:0;
    // base do funil = primeira etapa visível (visual. da página) = 100%
    var base=lpv||cart||chk||res||0;
    var detPagos='Pedidos: '+NUM(res)+(naoPagos?'\nNão pagos (tráfego): -'+NUM(naoPagos):'')+'\nPagos: '+NUM(pagos);
    var detLpv='Visualizações: '+NUM(lpv)+(tblLpvRate!=null?'\nTaxa média (campanhas ativas): '+(tblLpvRate*100).toFixed(1).replace('.',',')+'%':'');
    var steps=[
      {n:'Visual. da página', ic:'page',     v:lpv,   cost:custoLpv,  ideal:0,               max:0,              pctOv:(tblLpvRate!=null?tblLpvRate:null)},
      {n:'Carrinho',          ic:'cart',     v:cart,  cost:custoCart, ideal:metas.cart_ideal, max:metas.cart_max},
      {n:'Checkout',          ic:'checkout', v:chk,   cost:custoChk,  ideal:metas.chk_ideal,  max:metas.chk_max},
      {n:'Pedidos',           ic:'buy',      v:res,   cost:cpa,       ideal:metas.cpa_ideal,  max:metas.cpa_max},
      {n:'Pedidos pagos',     ic:'check',    v:pagos, cost:cpaPago,   ideal:metas.cpa_ideal,  max:metas.cpa_max}
    ];
    $("#adp-funnel").innerHTML=acqFunnelSvg_(steps, base);
    var el=$("#adp-funnel-labels"); if(el) el.innerHTML='';
  }
  /* funil no mesmo design da página de produto (SVG de barras, escala raiz quadrada) */
  var ACQ_FUN_ICO={
    page:'<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>',
    cart:'<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>',
    checkout:'<rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/>',
    buy:'<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/>',
    check:'<polyline points="20 6 9 17 4 12"/>'
  };
  function acqFunnelSvg_(steps, base){
    // grade + barras + % acima; abaixo das barras: nome (cinza) e valor (amarelo bold)
    var W=580,H=110,padL=14,padR=14,baseY=94,topY=16,plotH=baseY-topY,N=steps.length,slotW=(W-padL-padR)/N;
    var FS=(window.innerWidth<=768?1.7:1);  // fontes maiores no mobile
    function hp(p){ p=Math.max(0,Number(p)||0); return p>0?Math.max(3,Math.sqrt(p)*plotH):0; }
    // gradientes verticais (topo claro → base mais escura) por status de custo
    var defs='<defs>'
      +'<linearGradient id="ffgY" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#fff200"/><stop offset="1" stop-color="#a99f00"/></linearGradient>'
      +'<linearGradient id="ffgG" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#48f91e"/><stop offset="1" stop-color="#2a9410"/></linearGradient>'
      +'<linearGradient id="ffgR" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#ff4d4d"/><stop offset="1" stop-color="#a12b2b"/></linearGradient>'
      +'</defs>';
    var grid='';
    for(var g=0;g<=4;g++){ var gy=(baseY-plotH*g/4).toFixed(1); grid+='<line x1="0" y1="'+gy+'" x2="'+W+'" y2="'+gy+'" stroke="#141414" stroke-width="0.5"/>'; }
    var bars='',labels='';
    for(var i=0;i<N;i++){ var s=steps[i], cx=padL+slotW*i+slotW/2;
      var pct=(s.pctOv!=null)?s.pctOv:(base?s.v/base:0), hh=hp(pct);
      var costCls=''; if(s.cost&&s.ideal){ costCls=s.cost<=s.ideal?'is-good':s.cost<=s.max?'':'is-bad'; }
      var fillColor = costCls==='is-good'?'#48f91e':costCls==='is-bad'?'#ff4d4d':'#fff200';
      var fillGrad  = costCls==='is-good'?'url(#ffgG)':costCls==='is-bad'?'url(#ffgR)':'url(#ffgY)';
      var pctStr=(base&&s.v)?((pct*100).toFixed(1).replace('.',',')+'%'):'-';
      bars+='<rect class="acq-fbar" x="'+(cx-11).toFixed(1)+'" y="'+(baseY-hh).toFixed(1)+'" width="22" height="'+hh.toFixed(1)+'" fill="'+fillGrad+'" style="color:'+fillColor+'" '
        +'data-fhov="1" data-fn="'+esc(s.n)+'" data-fv="'+s.v+'" data-fpct="'+pctStr+'" data-fcost="'+(s.cost||0)+'" data-fcls="'+costCls+'"></rect>';
      // acima da barra: o valor total (f2f2f2 bold)
      labels+='<text x="'+cx.toFixed(1)+'" y="'+(baseY-hh-5).toFixed(1)+'" text-anchor="middle" fill="#f2f2f2" font-size="'+(6*FS).toFixed(1)+'" font-weight="700" font-family="inherit">'+NUM(s.v)+'</text>';
      // abaixo da barra: nome do item + porcentagem (amarelo bold) — pouca distância entre eles
      labels+='<text x="'+cx.toFixed(1)+'" y="'+(baseY+8.5).toFixed(1)+'" text-anchor="middle" fill="#8a8a8a" font-size="'+(4*FS).toFixed(1)+'" style="text-transform:uppercase" letter-spacing=".02">'+esc(s.n)+'</text>';
      labels+='<text x="'+cx.toFixed(1)+'" y="'+(baseY+14.5).toFixed(1)+'" text-anchor="middle" fill="#fff200" font-size="'+(5*FS).toFixed(1)+'" font-weight="700" font-family="inherit">'+pctStr+'</text>';
    }
    return '<div style="width:100%;padding:6px 0 2px"><svg viewBox="0 0 '+W+' '+H+'" preserveAspectRatio="xMidYMid meet" style="width:100%;height:auto;display:block">'
      +defs+grid+'<line x1="0" y1="'+baseY+'" x2="'+W+'" y2="'+baseY+'" stroke="#2a2a2a" stroke-width="1"/>'+bars+labels+'</svg></div>';
  }
  /* ── gráfico de linha (evolução diária do custo) para o modo Visualização ── */
  var ACQ_MES_ABR=['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'];
  function acqDShort_(iso){ var p=String(iso).split('-'); if(p.length!==3) return iso; return (+p[2])+' '+(ACQ_MES_ABR[(+p[1])-1]||p[1]); }
  // data amigável no tooltip: "24 Mar"
  function acqDLong_(iso){ var p=String(iso).split('-'); if(p.length!==3) return iso; return (+p[2])+' '+(ACQ_MES_ABR[(+p[1])-1]||p[1]); }
  /* gráfico de linha multi-série (métrica primária + comparações sobrepostas) */
  /* cores fixas das comparações (sempre as mesmas): vermelho, azul, laranja, rosa,
     depois roxo, ciano, verde, magenta — todos em alto contraste e longe do amarelo */
  var CMP_PALETTE=['#ff5c5c','#4da6ff','#ff9f45','#ff7ac2','#b18cff','#2dd4bf','#22c55e','#e879f9'];
  var LINE_COLORS=CMP_PALETTE;
  /* escurece um hex por um fator (0-1) — usado no degradê das barras (igual funil) */
  function _hexDark(h,f){ h=String(h).replace('#',''); if(h.length===3) h=h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
    var r=Math.round(parseInt(h.slice(0,2),16)*f), g=Math.round(parseInt(h.slice(2,4),16)*f), b=Math.round(parseInt(h.slice(4,6),16)*f);
    return '#'+[r,g,b].map(function(x){ return ('0'+Math.max(0,Math.min(255,x)).toString(16)).slice(-2); }).join(''); }
  /* curva suave (Catmull-Rom → bézier), mesmo estilo do gráfico da home */
  function _smoothPath(p){
    if(!p.length) return '';
    if(p.length<3) return 'M '+p.map(function(q){return q[0].toFixed(2)+' '+q[1].toFixed(2);}).join(' L ');
    var t=0.16, d='M '+p[0][0].toFixed(2)+' '+p[0][1].toFixed(2);
    for(var i=0;i<p.length-1;i++){
      var p0=p[i-1]||p[i], p1=p[i], p2=p[i+1], p3=p[i+2]||p2;
      var c1x=p1[0]+(p2[0]-p0[0])*t, c1y=p1[1]+(p2[1]-p0[1])*t;
      var c2x=p2[0]-(p3[0]-p1[0])*t, c2y=p2[1]-(p3[1]-p1[1])*t;
      d+=' C '+c1x.toFixed(2)+' '+c1y.toFixed(2)+' '+c2x.toFixed(2)+' '+c2y.toFixed(2)+' '+p2[0].toFixed(2)+' '+p2[1].toFixed(2);
    }
    return d;
  }
  var _lineState=null; // {days:[], series:[{lbl,color,vals:[]}]}
  function acqAxis_(v,fmt){ if(fmt==='pct') return (v*100).toFixed(0)+'%'; if(fmt==='num') return NUM(Math.round(v)); return 'R$'+BRL(v).replace('R$','').trim(); }
  function acqFmtVal_(v,fmt){ if(fmt==='pct') return PCT(v); if(fmt==='num') return NUM(v); return BRL(v); }
  /* gráfico multi-série (linha ou barra) para o modo Visualização */
  var _chartGeo=null; // geometria p/ o hover (guia + bolinhas)
  function acqChartSvg_(days, seriesArr, pfmt, type){
    if(!days||!days.length) return '<p class="mc-empty">Sem dados no período</p>';
    var Z=chartZoom||1, W=580,H=112,padL=40,padR=40,padT=16,plotH=78,plotW=W-padL-padR,baseY=padT+plotH,n=days.length;
    var FS=(window.innerWidth<=768?1.7:1);  // fontes maiores no mobile (compensa o encolhimento do viewBox largo)
    var max=0; seriesArr.forEach(function(s){ s.vals.forEach(function(v){ if(v>max) max=v; }); });
    if(max<=0) max=1;
    /* tetos fixos por métrica de porcentagem (valores em fração 0-1) */
    function acqPctCap_(lbl){ var t=String(lbl||'').toLowerCase();
      if(t.indexOf('ctr')>=0) return 0.10;
      if(t.indexOf('checkout')>=0) return 0.10;
      if(t.indexOf('carrinho')>=0) return 0.20;
      if(t.indexOf('aquisi')>=0) return 0.05;
      return 0;
    }
    /* teto independente por formato: custo (brl) e porcentagem (pct) coexistem sem se sobrepor */
    var maxByFmt={};
    ['pct','brl','num'].forEach(function(f){
      var mv=0; seriesArr.forEach(function(s){ if(s.fmt!==f) return; s.vals.forEach(function(v){ if(v>mv) mv=v; }); });
      if(mv<=0){ maxByFmt[f]=0; return; }
      if(f==='pct'){ var cap=0; seriesArr.forEach(function(s){ if(s.fmt==='pct'){ var c=acqPctCap_(s.lbl); if(c>cap) cap=c; } });
        // teto fixo no valor definido; só adapta pra cima se a maior % do gráfico superar o teto
        maxByFmt[f]= cap>0 ? (mv>cap ? mv*1.12 : cap) : mv*1.12;
      } else { maxByFmt[f]=mv*1.12; }
    });
    var niceMax = maxByFmt[pfmt] || max*1.12;               // eixo Y = formato primário
    function nmFor(fmt){ return maxByFmt[fmt] || niceMax; }
    var band=plotW/n;
    /* ctrl+scroll: curva de raiz que afeta os valores na vertical (a grade permanece fixa).
       Z>1 = raiz (pExp<1) → todos os valores sobem; Z<1 = comprime (pExp>1). Z=1 = linear. */
    var pExp=1/Z;
    function vmap(v,fmt){ var nm=nmFor(fmt||pfmt); v=Math.max(0,Number(v)||0); return v>0?Math.pow(v/nm,pExp):0; }
    // pontos de ponta a ponta: 1º no início e último no fim das linhas horizontais (sem recuo de meia-faixa)
    function X(i){ return n>1 ? padL + plotW*i/(n-1) : padL + plotW/2; }
    function Y(v,fmt){ return baseY - vmap(v,fmt)*plotH; }
    var cxs=[]; for(var q=0;q<n;q++) cxs.push(X(q));
    _chartGeo={cxs:cxs, padT:padT, baseY:baseY};
    var defs='<defs><linearGradient id="adpArea" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#fff200" stop-opacity="0.5"/><stop offset="1" stop-color="#fff200" stop-opacity="0.02"/></linearGradient>'
      +'<linearGradient id="adpGuide" gradientUnits="userSpaceOnUse" x1="0" y1="4" x2="0" y2="'+baseY+'"><stop offset="0" stop-color="#f2f2f2" stop-opacity="0"/><stop offset="0.22" stop-color="#f2f2f2" stop-opacity="0.8"/><stop offset="0.78" stop-color="#f2f2f2" stop-opacity="0.8"/><stop offset="1" stop-color="#f2f2f2" stop-opacity="0"/></linearGradient></defs>';
    var grid='',yl='';
    // rótulos do eixo Y = inverso da vmap: em cada linha fixa (altura g/4) mostra niceMax·(g/4)^Z,
    // então os valores acompanham a curva de raiz do ctrl+scroll (a posição das linhas continua fixa)
    for(var g=0;g<=4;g++){ var gv=niceMax*Math.pow(g/4,Z), gy=baseY-plotH*g/4, isBase=(g===0);
      // base (g=0): sólida e levemente mais clara; demais: pontilhadas
      grid+='<line x1="'+padL+'" y1="'+gy.toFixed(1)+'" x2="'+(W-padR)+'" y2="'+gy.toFixed(1)+'" stroke="'+(isBase?'#333':'#1a1a1a')+'" stroke-width="0.5"'+(isBase?'':' stroke-dasharray="1.4 1.4"')+'/>';
      yl+='<text x="'+(padL-6)+'" y="'+(gy-2).toFixed(1)+'" text-anchor="end" fill="#8a8a8a" font-size="'+(4.4*FS).toFixed(1)+'" font-weight="700" font-family="inherit">'+acqAxis_(gv,pfmt)+'</text>';
    }
    var body='';
    if(type==='bar'){
      var S=seriesArr.length, groupW=band*(S===1?0.34:0.72), barW=groupW/S;  // sem comparação: barras mais finas
      // degradê por série (topo na cor → base escurecida), igual às barras do funil
      var barDefs='<defs>'; seriesArr.forEach(function(s,si){ barDefs+='<linearGradient id="adpBar'+si+'" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="'+s.color+'"/><stop offset="1" stop-color="'+_hexDark(s.color,.5)+'"/></linearGradient>'; }); barDefs+='</defs>';
      var bbody='';
      for(var i=0;i<n;i++){ for(var si=0;si<S;si++){ var v=seriesArr[si].vals[i]||0, h=Math.max(0,vmap(v,seriesArr[si].fmt)*plotH), bx=(padL+band*(i+0.5))-groupW/2+si*barW, w2=barW*(S===1?0.9:0.88), topY=baseY-h;
        bbody+='<rect class="adp-bar" x="'+bx.toFixed(1)+'" y="'+topY.toFixed(1)+'" width="'+w2.toFixed(1)+'" height="'+h.toFixed(1)+'" rx="0.6" fill="url(#adpBar'+si+')" style="color:'+seriesArr[si].color+'"/>';
        if(v>0) bbody+='<text x="'+(bx+w2/2).toFixed(1)+'" y="'+(topY-1.8).toFixed(1)+'" text-anchor="middle" fill="#f2f2f2" font-size="'+(3.8*FS).toFixed(1)+'" font-family="inherit">'+esc(acqAxis_(v,pfmt))+'</text>';  // valor acima da barra
      } }
      body=barDefs+bbody;
    } else {
      // primária (idx 0): área com degradê descendo + linha suave; comparações: tracejadas sem preenchimento
      seriesArr.forEach(function(s,si){
        var pts=s.vals.map(function(v,i){ return [X(i), Y(v,s.fmt)]; });
        var line=_smoothPath(pts);
        if(si===0){
          var area=line+' L '+X(n-1).toFixed(2)+' '+baseY.toFixed(2)+' L '+X(0).toFixed(2)+' '+baseY.toFixed(2)+' Z';
          body+='<path d="'+area+'" fill="url(#adpArea)" stroke="none"/>';
          body+='<path d="'+line+'" fill="none" stroke="'+s.color+'" stroke-width="0.7" stroke-linejoin="round" stroke-linecap="round"/>';
        } else {
          body+='<path d="'+line+'" fill="none" stroke="'+s.color+'" stroke-width="0.55" stroke-dasharray="2 1.6" stroke-linejoin="round" stroke-linecap="round"/>';
        }
      });
      // bolinhas vazadas por cima
      seriesArr.forEach(function(s,si){ s.vals.forEach(function(v,i){ body+='<circle class="adp-dot" data-di="'+i+'" data-si="'+si+'" cx="'+X(i).toFixed(1)+'" cy="'+Y(v,s.fmt).toFixed(1)+'" r="1.5" fill="#0d0d0d" stroke="'+s.color+'" stroke-width="0.7"/>'; }); });
    }
    // guia vertical (segue o mouse) + grupo de destaque das bolinhas
    // guia vertical branca, do topo (acima da última grade) até a base
    var guide='<line class="adp-guide" x1="0" y1="4" x2="0" y2="'+baseY+'" stroke="url(#adpGuide)" stroke-width="0.3" style="display:none"/><g class="adp-hovg"></g>';
    var slices='',xl='',step=Math.max(1,Math.ceil(n/8));
    for(var j=0;j<n;j++){ var cx=X(j);
      slices+='<rect data-lslice="1" data-lidx="'+j+'" x="'+(cx-band/2).toFixed(1)+'" y="'+padT+'" width="'+band.toFixed(1)+'" height="'+plotH+'" fill="transparent" style="cursor:crosshair"></rect>';
      if(j%step===0||j===n-1) xl+='<text x="'+cx.toFixed(1)+'" y="'+(baseY+9).toFixed(1)+'" text-anchor="middle" fill="#8a8a8a" font-size="'+(4.2*FS).toFixed(1)+'" font-weight="700" font-family="inherit">'+esc(acqDShort_(days[j]).toUpperCase())+'</text>';
    }
    // altura fixa (proporção natural, sem distorção); o ctrl+scroll mexe só no mapeamento de potência (vmap)
    // altura NATURAL (mesma proporção do viewBox → escala uniforme, sem esticar/achatar)
    var host=root.querySelector("#adp-funnel"), cw=(host&&host.clientWidth)||760, hpx=Math.round(cw*H/W);
    // botão "voltar ao padrão" (aparece só quando há zoom via ctrl+scroll)
    var reset=(Z!==1)?'<button type="button" class="adp-zreset" title="Voltar ao padrão"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"></polyline><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path></svg></button>':'';
    /* legenda em linha, fora do svg mas dentro do bloco (quadrado da cor + nome da métrica) */
    var legendHtml='<div style="display:flex;flex-wrap:wrap;justify-content:center;gap:20px;padding:6px 4px 2px;font-size:11px;color:#c8c8c8">'
      +seriesArr.map(function(s){ return '<span style="display:inline-flex;align-items:flex-end;gap:5px;line-height:1"><span style="width:9px;height:9px;background:'+s.color+';display:inline-block"></span>'+esc(String(s.lbl||''))+'</span>'; }).join('')
      +'</div>';
    return '<div style="position:relative;width:100%;padding:6px 0 2px">'+reset+'<svg class="adp-chart" viewBox="0 0 '+W+' '+H+'" preserveAspectRatio="none" style="width:100%;height:'+hpx+'px;display:block;overflow:hidden">'+defs+grid+yl+body+guide+slices+xl+'</svg>'+legendHtml+'</div>';
  }
  /* ── modo de visualização (funil x gráfico de métricas diárias) ── */
  var viewMode='funil', viewChart='line', chartZoom=1, seriesData=null, seriesKey='', cmpMetrics=[], cmpSync=function(){};
  /* ctrl+scroll sobre o gráfico: aumenta/diminui a distância entre os extremos (zoom horizontal) */
  (function(){ var host=$("#adp-funnel"); if(!host) return;
    host.addEventListener("wheel",function(e){
      if(!e.ctrlKey) return; if(viewMode==='funil'||viewMode==='eventos') return;
      e.preventDefault();
      chartZoom=Math.min(8,Math.max(0.4, chartZoom + (e.deltaY<0?0.25:-0.25)));
      renderSeries();
    },{passive:false});
    host.addEventListener("click",function(e){
      if(!e.target.closest(".adp-zreset")) return;
      if(viewMode==='funil'||viewMode==='eventos') return;
      chartZoom=1; renderSeries();
    });
  })();
  var SERIES_META={
    ctr:       {f:'ctr',       lbl:'CTR',            short:'ctr',            fmt:'pct', tax:0},
    cart_custo:{f:'custo_cart',lbl:'Carrinho custo', short:'carrinho custo', fmt:'brl', tax:1},
    cart_pct:  {f:'cart_pct',num:'cart',den:'lpv',lbl:'Carrinho %',short:'carrinho %',fmt:'pct', tax:0},
    cart_total:{f:'cart',      lbl:'Carrinho total', short:'carrinho total', fmt:'num', tax:0, cum:1},
    chk_custo: {f:'custo_chk', lbl:'Checkout custo', short:'checkout custo', fmt:'brl', tax:1},
    chk_pct:   {f:'chk_pct',num:'chk',den:'lpv',lbl:'Checkout %',short:'checkout %',fmt:'pct', tax:0},
    chk_total: {f:'chk',       lbl:'Checkout total', short:'checkout total', fmt:'num', tax:0, cum:1},
    aq_custo:  {f:'cpa',       lbl:'Aquisição custo',short:'aquisição custo',fmt:'brl', tax:1},
    aq_pct:    {f:'aq_pct',num:'aquisicao',den:'lpv',lbl:'Aquisição %',short:'aquisição %',fmt:'pct', tax:0},
    aq_total:  {f:'aquisicao', lbl:'Aquisição total',short:'aquisição total',fmt:'num', tax:0, cum:1},
    ticket:    {f:'ticket',    lbl:'Ticket médio',   short:'ticket médio',   fmt:'brl', tax:0}
  };
  var METRIC_ORDER=['cart_custo','cart_pct','cart_total','chk_custo','chk_pct','chk_total','aq_custo','aq_pct','aq_total','ticket'];
  function seriesCurKey(){ var s2=selParams(); return apiRange(dateRange)+'|'+obj+'|'+s2.camp_ids+'|'+s2.adset_ids+'|'+s2.ad_ids; }
  function metricVals(k){ var m=SERIES_META[k], acc=0; return (seriesData||[]).map(function(r){
    var v;
    if(m.f!=null && r[m.f]!=null){ v=Number(r[m.f])||0; if(m.tax) v*=META_TAX; }          // usa o campo do backend
    else if(m.num&&m.den){ var den=Number(r[m.den])||0; v=den?(Number(r[m.num])||0)/den:0; } // fallback: % = num/lpv
    else { v=0; }
    if(m.cum){ acc+=v; return acc; }  // total acumulado ao longo do tempo
    return v;
  }); }
  /* Eventos: funil-style com o acumulado (visual. destino, carrinho, checkout, pedidos) */
  function renderEventos(){
    var L=curEnts();
    var lpv=sum(L,'lpv'), cart=sum(L,'carrinho'), chk=sum(L,'checkout'), res=sum(L,'resultados');
    var base=lpv||cart||chk||res||0;
    var steps=[
      {n:'Visual. destino', ic:'page',     v:lpv},
      {n:'Carrinho',        ic:'cart',     v:cart},
      {n:'Checkout',        ic:'checkout', v:chk},
      {n:'Pedidos',         ic:'buy',      v:res}
    ];
    $("#adp-funnel").innerHTML=acqFunnelSvg_(steps, base);
    var el=$("#adp-funnel-labels"); if(el) el.innerHTML='';
  }
  function renderSeries(){
    var m=SERIES_META[viewMode]; if(!m){ if(viewMode==='eventos') renderEventos(); else renderFunnel(); return; }
    updMetricsTitle();
    var days=(seriesData||[]).map(function(r){ return r.date; });
    var seriesArr=[{lbl:m.lbl, color:'#fff200', vals:metricVals(viewMode), fmt:m.fmt}];
    cmpMetrics.forEach(function(k,idx){ var cm=SERIES_META[k]; if(!cm) return; seriesArr.push({lbl:cm.lbl, color:LINE_COLORS[idx%LINE_COLORS.length], vals:metricVals(k), fmt:cm.fmt}); });
    _lineState={days:days, series:seriesArr};
    $("#adp-funnel").innerHTML=acqChartSvg_(days, seriesArr, m.fmt, viewChart);
    var el=$("#adp-funnel-labels"); if(el) el.innerHTML='';
  }
  /* deriva a série de um período custom (a~b) fatiando uma série maior já baixada (30d/mês/ano/máx) → instantâneo e exato */
  function deriveSeriesFromSuperset_(rng){
    if(!rng || rng.indexOf('~')<0) return null;
    var p=rng.split('~'), a=p[0], b=p[1];
    var cands=['max','ano','mes','30d','7d'];
    for(var i=0;i<cands.length;i++){
      try{ var c=localStorage.getItem('mc_adseries_v5_'+obj+'_'+cands[i]); if(!c) continue;
        var j=JSON.parse(c), arr=j&&j.d&&j.d.series; if(!arr||!arr.length) continue;
        if(arr[0].date<=a && arr[arr.length-1].date>=b){
          var sliced=arr.filter(function(r){ return r.date>=a && r.date<=b; });
          if(sliced.length) return sliced;
        }
      }catch(e){}
    }
    return null;
  }
  /* janela [a,b] em ISO de um range (p/ derivar do dataset diário) */
  function acqRangeISO_(rng){
    var t=new Date(); t.setHours(0,0,0,0);
    function iso(d){ return d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+('0'+d.getDate()).slice(-2); }
    var today=iso(t);
    if(rng.indexOf('~')>0){ var p=rng.split('~'); return {a:p[0], b:p[1]}; }
    if(rng==='hoje') return {a:today, b:today};
    if(rng==='hoje_ontem') return {a:iso(new Date(t.getTime()-864e5)), b:today};
    if(rng==='7d') return {a:iso(new Date(t.getTime()-6*864e5)), b:today};
    if(rng==='30d') return {a:iso(new Date(t.getTime()-29*864e5)), b:today};
    if(rng==='6m'){ var d=new Date(t); d.setMonth(d.getMonth()-6); return {a:iso(d), b:today}; }
    if(rng==='ano') return {a:t.getFullYear()+'-01-01', b:today};
    if(rng==='max') return {a:'2000-01-01', b:today};
    return {a:iso(new Date(t.getTime()-29*864e5)), b:today};
  }
  /* TURBO: deriva a série de QUALQUER período somando o dataset diário (mc_adsdaily) no navegador */
  function buildSeriesFromDaily_(rng){
    try{
      var c=localStorage.getItem('mc_adsdaily_'+obj); if(!c) return null;
      var j=JSON.parse(c), dd=j&&j.d; if(!dd||!dd.rows||!dd.rows.length) return null;
      var win=acqRangeISO_(rng);
      if(rng==='max'){ var mn=null; dd.rows.forEach(function(r){ if(!mn||r.d<mn) mn=r.d; }); if(mn) win={a:mn,b:win.b}; }  // do 1º dia com dados
      var byDate={};
      dd.rows.forEach(function(r){ if(r.d<win.a||r.d>win.b) return;
        var o=byDate[r.d]||(byDate[r.d]={s:0,im:0,ck:0,ca:0,ch:0,pu:0,vl:0,lp:0});
        o.s+=r.s||0; o.im+=r.im||0; o.ck+=r.ck||0; o.ca+=r.ca||0; o.ch+=r.ch||0; o.pu+=r.pu||0; o.vl+=r.vl||0; o.lp+=r.lp||0;
      });
      // preenche todos os dias do período (zeros) p/ o gráfico não ficar esparso
      (function(){ var d0=new Date(win.a+'T00:00:00'), d1=new Date(win.b+'T00:00:00'), g=0;
        for(var dt=new Date(d0); dt<=d1 && g<400; dt.setDate(dt.getDate()+1), g++){
          var ds=dt.getFullYear()+'-'+('0'+(dt.getMonth()+1)).slice(-2)+'-'+('0'+dt.getDate()).slice(-2);
          if(!byDate[ds]) byDate[ds]={s:0,im:0,ck:0,ca:0,ch:0,pu:0,vl:0,lp:0};
        }
      })();
      var r2=function(x){return Math.round((x||0)*100)/100;}, r4=function(x){return Math.round((x||0)*10000)/10000;};
      return Object.keys(byDate).sort().map(function(d){ var o=byDate[d], base=o.lp||0;
        return { date:d,
          custo_cart:o.ca?r2(o.s/o.ca):0, custo_chk:o.ch?r2(o.s/o.ch):0, cpa:o.pu?r2(o.s/o.pu):0, ticket:o.pu?r2(o.vl/o.pu):0,
          cart:o.ca, chk:o.ch, aquisicao:o.pu, lpv:base,
          ctr:o.im?r4(o.ck/o.im):0, cart_pct:base?r4(o.ca/base):0, chk_pct:base?r4(o.ch/base):0, aq_pct:base?r4(o.pu/base):0,
          spend:r2(o.s) };
      });
    }catch(e){ return null; }
  }
  function loadSeries(){
    var box=$("#adp-funnel"), key=seriesCurKey(), rng=apiRange(dateRange);
    if(seriesData && seriesKey===key){ renderSeries(); return; }
    var s2=selParams(), isDefault=!s2.camp_ids&&!s2.adset_ids&&!s2.ad_ids;
    // cacheia também por seleção (marcar/desmarcar o mesmo item volta instantâneo)
    var lsKey=isDefault?('mc_adseries_v5_'+obj+'_'+rng):('mc_adseries_v5_'+obj+'_'+rng+'_'+s2.camp_ids+'_'+s2.adset_ids+'_'+s2.ad_ids), hadCache=false;
    // usa o cache baixado (botão "Baixar dados"/prefetch) na hora
    if(lsKey){ try{ var c=localStorage.getItem(lsKey); if(c){ var j=JSON.parse(c); if(j&&j.d){ seriesData=(j.d.series)||[]; seriesKey=key; hadCache=true; if(viewMode!=='funil') renderSeries(); } } }catch(e){} }
    // TURBO: se há dataset diário baixado, deriva a série na hora (qualquer período, incl. 6 meses)
    if(!hadCache && isDefault){
      var dser=buildSeriesFromDaily_(rng);
      if(dser && dser.length){ seriesData=dser; seriesKey=key;
        if(lsKey) try{ localStorage.setItem(lsKey,JSON.stringify({ts:Date.now(),d:{series:dser}})); }catch(e){}
        if(viewMode!=='funil') renderSeries();
        return;
      }
    }
    // período custom sem cache direto: fatia de uma série maior já baixada (exato, sem re-busca)
    if(!hadCache && isDefault && rng.indexOf('~')>0){
      var der=deriveSeriesFromSuperset_(rng);
      if(der){ seriesData=der; seriesKey=key;
        if(lsKey) try{ localStorage.setItem(lsKey,JSON.stringify({ts:Date.now(),d:{series:der}})); }catch(e){}
        if(viewMode!=='funil') renderSeries();
        return;
      }
    }
    if(!hadCache){ renderChartPlaceholder(); }
    // período passado com cache válido → instantâneo, não re-busca
    if(hadCache && lsKey && _rangeFresh(lsKey,rng) && !_rangeIncludesToday(rng)) return;
    call({resource:"ads_series",objective:obj,camp_ids:s2.camp_ids,adset_ids:s2.adset_ids,ad_ids:s2.ad_ids,range:rng}).then(function(d){
      if(d&&d.error){ if(!hadCache) box.innerHTML='<p class="mc-empty">Erro: '+esc(d.error)+'</p>'; return; }
      if(lsKey) try{ localStorage.setItem(lsKey,JSON.stringify({ts:Date.now(),d:d})); }catch(e){}
      seriesData=(d&&d.series)||[]; seriesKey=key; if(viewMode!=='funil') renderSeries();
    }).catch(function(e){ if(!hadCache) box.innerHTML='<p class="mc-empty">Erro: '+esc(e.message)+'</p>'; });
  }
  function metricsTitle(){
    if(viewMode==='funil') return 'Conversão';
    if(viewMode==='eventos') return 'Eventos';
    var m=SERIES_META[viewMode]; if(!m) return 'Análise de métricas';
    return m.lbl + cmpMetrics.map(function(k){ return SERIES_META[k]?(' / '+SERIES_META[k].short):''; }).join('') + ' / dia';
  }
  function updMetricsTitle(){ var t=$("#adp-metrics-title"); if(t) t.textContent=metricsTitle(); }
  function updChartToggle(){ var t=$("#adp-chart-toggle"); if(t) t.style.display=(viewMode==='funil'||viewMode==='eventos')?'none':''; }
  function renderCurrentView(){
    updMetricsTitle(); updChartToggle();
    if(viewMode==='funil'){ renderFunnel(); return; }
    if(viewMode==='eventos'){ renderEventos(); return; }
    if(seriesData && seriesKey===seriesCurKey()) renderSeries(); else loadSeries();
  }

  /* ── render chips 3-colunas ── */
  function renderChips(){
    var ch=$("#ac-chips"); if(!ch) return;
    var L=curEnts();
    var spend=sum(L,'spend'),res=sum(L,'resultados'),cart=sum(L,'carrinho'),chk=sum(L,'checkout');
    var resLiq=Math.max(0,res-(cancelados.count||0));
    var cpa=resLiq?spend/resLiq:0, custoCart=cart?spend/cart:0, custoChk=chk?spend/chk:0;
    // referência: período < 3 dias → últimos 7 dias; >= 3 dias → seleção atual
    var useRef7d = rangeDays() < 3;
    var refPeriodo = useRef7d ? 'últimos 7 dias' : rangeLabel(dateRange);
    var refTip = useRef7d
      ? 'Período menor que 3 dias — métricas e metas têm como referência os últimos 7 dias'
      : 'Metas calculadas com base na seleção atual: '+rangeLabel(dateRange);
    function valCls(v,ideal,max){ if(!v||!ideal)return''; return v<=ideal?'is-good':v<=max?'':'is-bad'; }
    function chip3(icon,nome,val,ideal,max,detail){
      var cls=valCls(val,ideal,max);
      var subHtml=ideal
        ?'<div class="chip3-sub" title="'+esc(refTip)+'">Ideal: '+BRL(ideal)+'</div><div class="chip3-sub" title="'+esc(refTip)+'">Máx: '+BRL(max)+'</div>'
        :'<div class="chip3-sub" style="color:var(--mut);font-size:10px">sem referência</div>';
      var tipA=val?' data-tt="1" data-name="'+esc(nome)+'" data-val="'+val+'" data-fmt="brl" data-lower="1" data-ideal="'+(ideal||0)+'" data-max="'+(max||0)+'" data-media="0"'+(detail?' data-detail="'+esc(detail)+'"':''):'';
      return '<div class="mc-chip3">'+
        '<div class="chip3-icon">'+ic(icon)+'</div>'+
        '<div class="chip3-nm">'+esc(nome)+'</div>'+
        '<div class="chip3-val tt '+cls+'"'+tipA+'>'+(val?BRL(val):'-')+'</div>'+
        subHtml+
        '</div>';
    }
    /* chip ticket médio */
    var convTotal=sum(L,'conversao_valor');
    var fatLiq=convTotal-(cancelados.valor||0);
    var ticket=resLiq?fatLiq/resLiq:0;
    /* ticket delta: usa kpiPrev (período proporcional) ou fallback 7d */
    var prevTicket=0, prevTicketLbl='período anterior';
    if(kpiPrev&&kpiPrev.resultados&&kpiPrev.conversao_valor){
      var pResLiq=Math.max(0,(kpiPrev.resultados||0)-(kpiPrev.cancelados_count||0));
      prevTicket=pResLiq?(kpiPrev.conversao_valor/pResLiq):0;
      prevTicketLbl=prevPeriodLabel()||'período anterior';
    } else {
      prevTicket=media.ticket_7d||media.ticket_30d||0;
      prevTicketLbl='semana passada';
    }
    var tkDiff=prevTicket&&ticket?ticket-prevTicket:0;
    function chipTicket(){
      var up=tkDiff>0;
      var diffHtml=prevTicket&&tkDiff
        ?'<div class="chip3-delta '+(up?'is-good':'is-bad')+'" title="Ticket médio - '+prevTicketLbl+': '+BRL(prevTicket)+'">'+(up?'+':'')+BRL(tkDiff)+'<div class="chip3-delta-sub">'+prevTicketLbl+'</div></div>'
        :'';
      return '<div class="mc-chip3">'+
        '<div class="chip3-icon">'+ic(ICN.ticket)+'</div>'+
        '<div class="chip3-nm">Ticket Médio</div>'+
        '<div class="chip3-val">'+(ticket?BRL(ticket):'-')+'</div>'+
        diffHtml+
      '</div>';
    }
    /* ── metas dinâmicas baseadas no ticket médio do próprio período ──
       CPA ideal = 30% do ticket; CPA máx = ticket − custo operacional médio
       (break-even). Carrinho/checkout derivam pelo funil (carrinhos/compra,
       checkouts/compra) do próprio período. */
    var avgCustoOp = (margemOp && Number(margemOp.n)>0) ? Number(margemOp.custo)/Number(margemOp.n) : 0;
    var cpaIdeal = ticket>0 ? ticket*0.30 : 0;
    var cpaMax   = (ticket>0 && avgCustoOp>0) ? Math.max(0, ticket-avgCustoOp) : 0;
    var cartRatio = res>0 ? cart/res : 0;  // carrinhos por compra
    var chkRatio  = res>0 ? chk/res  : 0;  // checkouts por compra
    var cartIdeal = cartRatio>0 ? cpaIdeal/cartRatio : 0;
    var cartMax   = cartRatio>0 ? cpaMax/cartRatio   : 0;
    var chkIdeal  = chkRatio>0  ? cpaIdeal/chkRatio  : 0;
    var chkMax    = chkRatio>0  ? cpaMax/chkRatio    : 0;

    var cpaDet='Resultados líq.: '+NUM(resLiq)+(cancelados.count?' — cancelados: '+cancelados.count:'')
      +'\nIdeal: 30% do ticket ('+BRL(ticket)+')'
      +(avgCustoOp>0?'\nMáx (break-even): ticket − custo op. médio ('+BRL(avgCustoOp)+'/ped., base '+NUM(margemOp.n||0)+' ped.)':'\nMáx: sem custos do período para calcular');
    ch.innerHTML='<div class="mc-chips3-wrap">'+
      '<div class="mc-chips3">'+
      chipTicket()+
      chip3(ICN.cpa,  'Custo por resultado', cpa,       cpaIdeal,  cpaMax, cpaDet)+
      chip3(ICN.cart, 'Custo por carrinho',  custoCart, cartIdeal, cartMax,'Carrinhos: '+NUM(cart)+(cartRatio>0?' · '+cartRatio.toFixed(1)+'/compra':''))+
      chip3(ICN.chk,  'Custo por checkout',  custoChk,  chkIdeal,  chkMax, 'Checkouts: '+NUM(chk)+(chkRatio>0?' · '+chkRatio.toFixed(1)+'/compra':''))+
      '</div>'+
      '</div>';
  }

  /* ── proporção linha única (abaixo da tabela) ── */
  function renderPropLine(){
    var el=$("#adp-prop-line"); if(!el) return;
    if(!metas.cart_ratio&&!metas.chk_ratio){ el.innerHTML=''; return; }
    function item(svg,label,val){
      return '<span class="mc-prop-item">'+svg+'<span class="pl-l">'+esc(label)+'</span><b class="pl-v">'+esc(String(val||'-'))+'</b></span>';
    }
    el.innerHTML='<div class="mc-prop-line" style="display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap">'
      +'<span style="display:flex;gap:20px;flex-wrap:wrap;align-items:center">'
      +item(ic(ICN.cart), 'Carrinhos/compra', metas.cart_ratio)
      +item(ic(ICN.chk),  'Checkouts/compra', metas.chk_ratio)
      +item(ic(ICN.prop), 'Conversão geral',  metas.cart_ratio?PCT(1/metas.cart_ratio):'-')
      +'</span>'
      +'</div>';
  }
  /* ── deduções manuais de eventos: botão direito numa célula de Carrinho/Checkout/Resultado ── */
  var _logAdj={}, _adjLoaded=false;
  /* colunas que aceitam dedução → [chave da dedução, rótulo] */
  var ADJ_METRIC={ total_cart:['carrinho','Carrinho'], total_chk:['checkout','Checkout'], resultados:['compra','Resultado'], total_compra:['compra','Compras'] };
  function ensureAdj(cb){
    if(_adjLoaded){ cb(); return; }
    call({resource:'ads_adj_list'}).then(function(d){
      _logAdj={}; ((d&&d.rows)||[]).forEach(function(r){ _logAdj[String(r.entity_id)]={carrinho:Number(r.carrinho)||0,checkout:Number(r.checkout)||0,compra:Number(r.compra)||0}; });
      _adjLoaded=true; cb();
    }).catch(function(){ _adjLoaded=true; cb(); });
  }
  function adjSave(id, nivel, nome){
    var a=_logAdj[id]||{carrinho:0,checkout:0,compra:0};
    call({resource:'ads_adj_save', entity_id:id, nivel:nivel, nome:nome, carrinho:a.carrinho||0, checkout:a.checkout||0, compra:a.compra||0}).then(function(){
      // recarrega tabela + KPIs/chips/funil/gráfico para refletir a dedução
      seriesData=null; seriesKey=''; loadCurrentLevel(); load();
    }).catch(function(){});
  }
  function adjEdit(id, nivel, nome, colKey, totalVal){
    var mk=ADJ_METRIC[colKey]; if(!mk) return;
    ensureAdj(function(){
      var cur=(_logAdj[id]||{})[mk[0]]||0;
      mcPrompt('Quantos '+mk[1].toLowerCase()+' subtrair de "'+(nome||id)+'"? (total atual: '+NUM(totalVal||0)+')', '0', cur?String(cur):'', 'Salvar').then(function(v){
        if(v===null) return;
        var num=Math.max(0, parseInt(String(v).replace(/[^0-9]/g,''),10)||0);
        if(!_logAdj[id]) _logAdj[id]={carrinho:0,checkout:0,compra:0};
        _logAdj[id][mk[0]]=num;
        adjSave(id, nivel, nome);
      });
    });
  }
  /* menu de contexto (botão direito) */
  var _adjMenu=null;
  function closeAdjMenu(){ if(_adjMenu&&_adjMenu.parentNode) _adjMenu.parentNode.removeChild(_adjMenu); _adjMenu=null; }

  /* ── render geral ── */
  /* KPIs/chips/funil/ranking consideram TODAS as campanhas (ativas + desativadas)
     por padrão. Com o "ocultar inativos" ligado, passam a ignorar as inativas. */
  function curEnts(){ return hideInactive ? ents.filter(function(e){ return e.ativo!==false; }) : ents; }
  function render(){
    // cada etapa isolada: um erro (ex.: dados nível-campanha em período longo) não trava as demais nem o loading
    try{ renderKpis(curEnts()); }catch(e){}
    try{ renderCurrentView(); }catch(e){}
    try{ renderChips(); }catch(e){}
    try{ renderPropLine(); }catch(e){}
  }

  /* ── ranking (lista ponderada) ── */
  function renderBest(){
    var box=$("#adp-best"),nav=$("#adp-caro-nav");
    if(!box) return;
    /* gasto mínimo de R$20 para entrar no ranking */
    var RANK_MIN_SPEND=20;
    var arr=best.filter(function(a){
      if(hideInactive && a.ativo===false) return false;
      if((Number(a.spend)||0) < RANK_MIN_SPEND) return false;
      return !search||String(a.nome||'').toLowerCase().indexOf(search)>=0;
    });
    /* pontuação ponderada: ROAS (↑), custo/carrinho (↓), custo/checkout (↓) — peso igual */
    var maxRoas=0, minCart=Infinity, minChk=Infinity;
    arr.forEach(function(a){
      var r=Number(a.roas)||0, cc=Number(a.custo_cart)||0, ck=Number(a.custo_chk)||0;
      if(r>maxRoas) maxRoas=r;
      if(cc>0&&cc<minCart) minCart=cc;
      if(ck>0&&ck<minChk) minChk=ck;
    });
    if(!isFinite(minCart)) minCart=0;
    if(!isFinite(minChk)) minChk=0;
    arr.forEach(function(a){
      var sRoas=maxRoas?((Number(a.roas)||0)/maxRoas):0;
      var cc=Number(a.custo_cart)||0, ck=Number(a.custo_chk)||0;
      var sCart=cc&&minCart?(minCart/cc):0;
      var sChk=ck&&minChk?(minChk/ck):0;
      var cnt=(maxRoas?1:0)+(minCart?1:0)+(minChk?1:0);
      a._score=cnt?(sRoas+sCart+sChk)/cnt:0;
    });
    /* mostra apenas anúncios com score acima da média — sem limite fixo de itens */
    if(arr.length>2){
      var avgScore=arr.reduce(function(s,a){return s+(a._score||0);},0)/arr.length;
      arr=arr.filter(function(a){ return (a._score||0)>=avgScore; });
    }
    arr.sort(function(a,b){ return b._score-a._score; });
    if(!arr.length){ box.innerHTML='<p class="mc-empty">'+(search?'Nenhum anúncio encontrado':'Sem anúncios acima da média no período (gasto mín. R$20)')+'</p>'; if(nav)nav.style.display='none'; return; }
    var pages=Math.ceil(arr.length/BEST_PER); if(bestPage>=pages)bestPage=0;
    bestPages=pages;
    var slice=arr.slice(bestPage*BEST_PER,bestPage*BEST_PER+BEST_PER);
    box.innerHTML=slice.map(function(a,i){
      var roas=Number(a.roas)||0;
      var roasStr=roas?roas.toFixed(2).replace('.',',')+'x':'-';
      var cartCls=a.cart_st?'is-'+a.cart_st:'', chkCls=a.chk_st?'is-'+a.chk_st:'';
      var rank=bestPage*BEST_PER+i+1;
      var imgUrl=a.img||'';
      return '<div class="mc-adcard">'+
        '<div class="mc-adcard-rank">#'+rank+'</div>'+
        '<div class="mc-adcard-hier">'+
          '<div class="mc-adcard-h mc-adcard-h-cp" title="Campanha: '+esc(a.campanha||'-')+'">'+esc(a.campanha||'-')+'</div>'+
          '<div class="mc-adcard-h mc-adcard-h-cj" title="Conjunto: '+esc(a.conjunto||'-')+'">'+esc(a.conjunto||'-')+'</div>'+
          '<div class="mc-adcard-h mc-adcard-h-ad" title="Anúncio: '+esc(a.nome||'-')+'">'+esc(a.nome||'-')+'</div>'+
        '</div>'+
        '<div class="mc-adcard-img" data-img="'+esc(imgUrl)+'">'+(imgUrl?'<img src="'+esc(imgUrl)+'" loading="lazy" style="width:100%;height:100%;object-fit:contain;display:block;">':'<span style="font-size:11px;color:var(--mut);display:flex;height:100%;align-items:center;justify-content:center">sem mídia</span>')+'</div>'+
        '<div class="mc-adcard-body">'+
          '<div class="mc-adcard-metrics">'+
            '<div class="mc-adcard-m"><span class="mc-adrank-ml">ROAS</span><span class="mc-adrank-mv tt" data-tt="1" data-name="ROAS" data-val="'+(Number(a.roas)||0)+'" data-media="0" data-ideal="0" data-max="0" data-fmt="mult" data-lower="0">'+roasStr+'</span></div>'+
            '<div class="mc-adcard-m"><span class="mc-adrank-ml">Custo/carr.</span><span class="mc-adrank-mv '+cartCls+' tt" data-tt="1" data-name="Custo/carrinho" data-val="'+(Number(a.custo_cart)||0)+'" data-media="'+(media.cart||0)+'" data-ideal="'+(metas.cart_ideal||0)+'" data-max="'+(metas.cart_max||0)+'" data-fmt="brl" data-lower="1">'+(a.custo_cart?BRL(a.custo_cart):'-')+'</span></div>'+
            '<div class="mc-adcard-m"><span class="mc-adrank-ml">Custo/chk.</span><span class="mc-adrank-mv '+chkCls+' tt" data-tt="1" data-name="Custo/checkout" data-val="'+(Number(a.custo_chk)||0)+'" data-media="'+(media.chk||0)+'" data-ideal="'+(metas.chk_ideal||0)+'" data-max="'+(metas.chk_max||0)+'" data-fmt="brl" data-lower="1">'+(a.custo_chk?BRL(a.custo_chk):'-')+'</span></div>'+
            '<div class="mc-adcard-m"><span class="mc-adrank-ml">Gasto</span><span class="mc-adrank-mv tt" data-tt="1" data-name="Gasto" data-val="'+(Number(a.spend)||0)+'" data-media="'+(media.spend||0)+'" data-ideal="0" data-max="0" data-fmt="brl" data-lower="0">'+(a.spend?BRL(a.spend):'-')+'</span></div>'+
          '</div>'+
        '</div>'+
      '</div>';
    }).join("");
    if(nav){ nav.style.display=pages>1?'':'none'; $("#adp-caro-pg").textContent=(bestPage+1)+'/'+pages; $("#adp-caro-prev").disabled=bestPage===0; $("#adp-caro-next").disabled=bestPage>=pages-1; }
  }
  (function(){ var p=$("#adp-caro-prev"),nx=$("#adp-caro-next");
    if(p) p.addEventListener("click",function(){ if(bestPage>0){bestPage--;renderBest();} });
    if(nx) nx.addEventListener("click",function(){ if(bestPage<bestPages-1){bestPage++;renderBest();} }); })();
  /* ── hover imagem anúncio ── */
  (function(){
    var imgTip=document.createElement("div");
    imgTip.className="mc-ad-imgtip";
    imgTip.style.cssText="display:none;position:fixed;z-index:9999;pointer-events:none;background:#000;border:1px solid rgba(255,255,255,0.15);border-radius:10px;padding:0;box-shadow:0 8px 32px rgba(0,0,0,0.7);overflow:hidden;width:180px;height:320px;";
    document.body.appendChild(imgTip);
    var imgTipImg=document.createElement("img");
    imgTipImg.style.cssText="display:block;width:100%;height:100%;object-fit:contain;border-radius:10px;";
    imgTip.appendChild(imgTipImg);
    var bestBox=$("#adp-best");
    if(bestBox){
      bestBox.addEventListener("mouseover",function(ev){
        var nm=ev.target.closest(".mc-adcard-img");
        if(!nm) return;
        var src=nm.getAttribute("data-img");
        if(!src) return;
        imgTipImg.src=src;
        imgTip.style.display="block";
      });
      bestBox.addEventListener("mousemove",function(ev){
        if(imgTip.style.display==="none") return;
        var x=ev.clientX+16, y=ev.clientY-160;
        if(x+190>window.innerWidth) x=ev.clientX-196;
        if(y<4) y=4;
        if(y+324>window.innerHeight) y=window.innerHeight-324;
        imgTip.style.left=x+"px"; imgTip.style.top=y+"px";
      });
      bestBox.addEventListener("mouseout",function(ev){
        var nm=ev.target.closest(".mc-adcard-img");
        if(!nm) return;
        imgTip.style.display="none";
      });
    }
  })();

  /* ── tooltip flutuante ── */
  var tipEl=document.createElement("div"); tipEl.className="mc-tip"; tipEl.style.display="none"; root.appendChild(tipEl);
  function fmtv(v,f){ if(f==='pct')return PCT(v); if(f==='mult')return (Number(v)||0).toFixed(2).replace('.',',')+'x'; if(f==='dec')return (Number(v)||0).toFixed(2).replace('.',','); if(f==='num')return NUM(v); return BRL(v); }
  function showTip(el,x,y){
    var name=el.getAttribute("data-name"),val=+el.getAttribute("data-val"),med=+el.getAttribute("data-media"),ideal=+el.getAttribute("data-ideal"),mx=+el.getAttribute("data-max"),f=el.getAttribute("data-fmt")||"brl",lower=el.getAttribute("data-lower");
    var h='<div class="tt-h">'+esc(name)+'</div><div class="tt-v">'+(val?fmtv(val,f):'-')+'</div>';
    if(med){ h+='<div class="tt-r"><span>média</span><span>'+fmtv(med,f)+'</span></div>'; }
    if(ideal){ h+='<div class="tt-r"><span>ideal</span><span>'+fmtv(ideal,f)+'</span></div><div class="tt-r"><span>máximo</span><span>'+fmtv(mx,f)+'</span></div>';
      if(val){ var st=val<=ideal?['dentro do ideal','good']:val<=mx?['até o máximo','ok']:['acima do máximo','bad']; h+='<div class="tt-pill '+st[1]+'">'+st[0]+'</div>'; } }
    var detail=el.getAttribute("data-detail");
    if(detail){ detail.split('\n').forEach(function(ln){ h+='<div class="tt-detail">'+esc(ln)+'</div>'; }); }
    tipEl.className="mc-tip"; tipEl.innerHTML=h; tipEl.style.display="block";
    var r=tipEl.getBoundingClientRect(),px=x+14,py=y+14;
    if(px+r.width>window.innerWidth) px=x-r.width-14; if(py+r.height>window.innerHeight) py=y-r.height-14;
    tipEl.style.left=Math.max(4,px)+"px"; tipEl.style.top=Math.max(4,py)+"px";
  }
  function showFunnelTip(bar,x,y){
    var nm=bar.getAttribute('data-fn')||'',n=Number(bar.getAttribute('data-fv'))||0,pct=bar.getAttribute('data-fpct')||'',cost=Number(bar.getAttribute('data-fcost'))||0,cls=bar.getAttribute('data-fcls')||'';
    var h='<div class="tt-h">'+esc(nm)+'</div>';
    h+='<div class="tt-r"><span>total</span><span>'+NUM(n)+'</span></div>';
    if(pct&&pct!=='-') h+='<div class="tt-r"><span>% do funil</span><span>'+esc(pct)+'</span></div>';
    if(cost) h+='<div class="tt-r"><span>custo/unidade</span><span class="'+(cls||'')+'">'+BRL(cost)+'</span></div>';
    tipEl.className='mc-tip'; tipEl.innerHTML=h; tipEl.style.display='block';
    var r=tipEl.getBoundingClientRect(),px=x+14,py=y+14;
    if(px+r.width>window.innerWidth) px=x-r.width-14; if(py+r.height>window.innerHeight) py=y-r.height-14;
    tipEl.style.left=Math.max(4,px)+'px'; tipEl.style.top=Math.max(4,py)+'px';
  }
  /* tooltip do gráfico de linha: mostra o valor de cada série no dia sob o cursor */
  /* guia vertical + destaque das bolinhas no dia sob o cursor */
  function acqLineFx_(idx){
    var svg=root.querySelector("#adp-funnel .adp-chart"); if(!svg||!_chartGeo) return;
    var cx=_chartGeo.cxs[idx]; if(cx==null) return;
    var guide=svg.querySelector('.adp-guide'); if(guide){ guide.setAttribute('x1',cx); guide.setAttribute('x2',cx); guide.style.display=''; }
    var hg=svg.querySelector('.adp-hovg'); if(hg){ var s='';
      Array.prototype.forEach.call(svg.querySelectorAll('.adp-dot[data-di="'+idx+'"]'),function(dot){
        s+='<circle cx="'+dot.getAttribute('cx')+'" cy="'+dot.getAttribute('cy')+'" r="0.7" fill="'+dot.getAttribute('stroke')+'"/>';
      });
      hg.innerHTML=s;
    }
  }
  function acqLineFxHide_(){ var svg=root.querySelector("#adp-funnel .adp-chart"); if(!svg) return; var g=svg.querySelector('.adp-guide'); if(g) g.style.display='none'; var hg=svg.querySelector('.adp-hovg'); if(hg) hg.innerHTML=''; }
  function showLineTip(idx,x,y){
    var st=_lineState; if(!st||!st.series.length) return;
    var d=st.days[idx]; if(d==null) return;
    acqLineFx_(idx);
    var h='<div class="lt-h">'+esc(acqDLong_(d))+'</div>';
    // formato: "- Carrinho custo: R$000"
    st.series.slice().sort(function(a,b){ return (Number(b.vals[idx])||0)-(Number(a.vals[idx])||0); }).forEach(function(s){ h+='<div class="lt-r"><span class="lt-sq" style="display:inline-block;width:8px;height:8px;background:'+s.color+';margin-right:5px;vertical-align:middle"></span><span class="lt-nm">'+esc(s.lbl)+':</span> <b>'+acqFmtVal_(s.vals[idx]||0, s.fmt||'brl')+'</b></div>'; });
    tipEl.className='mc-tip mc-tip-line'; tipEl.innerHTML=h; tipEl.style.display='block';
    var r=tipEl.getBoundingClientRect(),px=x+14,py=y+14;
    if(px+r.width>window.innerWidth) px=x-r.width-14; if(py+r.height>window.innerHeight) py=y-r.height-14;
    tipEl.style.left=Math.max(4,px)+'px'; tipEl.style.top=Math.max(4,py)+'px';
  }
  root.addEventListener("mousemove",function(ev){ var m=ev.target.closest("[data-tt]"); if(m){showTip(m,ev.clientX,ev.clientY);return;} var ls=ev.target.closest("[data-lslice]"); if(ls){showLineTip(+ls.getAttribute("data-lidx"),ev.clientX,ev.clientY);return;} acqLineFxHide_(); var fb=ev.target.closest("[data-fhov]"); if(fb){showFunnelTip(fb,ev.clientX,ev.clientY);return;} tipEl.style.display="none"; });
  root.addEventListener("mouseleave",function(){ tipEl.style.display="none"; acqLineFxHide_(); });

  /* ── tabela drill-down ── */
  var ADCOLS=[
    {k:'veiculacao',  t:'Veiculação',            f:'txt'},
    {k:'nome',        t:'Nome',                  f:'txt', fixed:true},
    {k:'valor_usado', t:'Valor usado',            f:'brl', fixed:true},
    {k:'orcamento',   t:'Orçamento',              f:'brl'},
    {k:'resultados',  t:'Resultados',             f:'num'},
    {k:'custo_resultado',t:'Custo/resultado',     f:'brl'},
    {k:'roas',        t:'ROAS',                   f:'mult'},
    {k:'valor_conversao',t:'Valor de conversão',  f:'brl'},
    {k:'cpm',         t:'CPM',                   f:'brl'},
    {k:'alcance',     t:'Alcance',               f:'num'},
    {k:'cliques_link',t:'Cliques no link',        f:'num'},
    {k:'ctr_link',    t:'CTR',                   f:'pct'},
    {k:'cpc_link',    t:'CPC',                   f:'brl'},
    {k:'lpv',         t:'Visual. página',         f:'num'},
    {k:'custo_lpv',   t:'Custo/visual. página',   f:'brl'},
    {k:'taxa_lpv',    t:'Taxa visual. página',    f:'pct'},
    {k:'custo_cart',  t:'Custo/carrinho',         f:'brl'},
    {k:'total_cart',  t:'Total carrinho',         f:'num'},
    {k:'custo_chk',   t:'Custo/checkout',         f:'brl'},
    {k:'total_chk',   t:'Total checkouts',        f:'num'},
    {k:'custo_compra',t:'Custo/compra',           f:'brl'},
    {k:'total_compra',t:'Total compras',          f:'num'},
    {k:'frequencia',  t:'Frequência',             f:'dec'},
    {k:'utm',         t:'UTM',                   f:'txt'}
  ];
  var ADDEF={veiculacao:1,nome:1,valor_usado:1,orcamento:1,resultados:1,custo_resultado:1,roas:1,cpm:1,ctr_link:1,cpc_link:1,custo_cart:1,custo_chk:1,custo_compra:1};
  function loadAdCols(){
    try{ var s=JSON.parse(localStorage.getItem("mc_adcols")); if(s&&s.order&&s.sel){ s.sel['valor_usado']=true; return s; } }catch(e){}
    var s2={}; ADCOLS.forEach(function(c){s2[c.k]=ADDEF[c.k]?true:false;});
    return {order:ADCOLS.map(function(c){return c.k;}),sel:s2};
  }
  function saveAdCols(){ try{ localStorage.setItem("mc_adcols",JSON.stringify(adcols)); }catch(e){} }
  var adcols=loadAdCols(), tbl={stack:[],rows:[]};
  /* status (veiculação) mais recente conhecido por entidade → toggle correto na hora, sem flash */
  var _stMap={}, _adDailyFetching=false;
  /* ── IndexedDB p/ o diário por anúncio (grande demais p/ localStorage) ── */
  var _idb=null, _adDailyMem=null;   // _adDailyMem = dado do diário por anúncio do objetivo atual (em memória)
  function idbOpen(cb){ if(_idb){ cb(_idb); return; } try{ var rq=indexedDB.open('mc_ads_db',1);
    rq.onupgradeneeded=function(e){ var db=e.target.result; if(!db.objectStoreNames.contains('kv')) db.createObjectStore('kv'); };
    rq.onsuccess=function(e){ _idb=e.target.result; cb(_idb); }; rq.onerror=function(){ cb(null); };
  }catch(e){ cb(null); } }
  function idbSet(key,val){ idbOpen(function(db){ if(!db) return; try{ db.transaction('kv','readwrite').objectStore('kv').put(val,key); }catch(e){} }); }
  function idbGet(key,cb){ idbOpen(function(db){ if(!db){ cb(null); return; } try{ var rq=db.transaction('kv','readonly').objectStore('kv').get(key); rq.onsuccess=function(){ cb(rq.result||null); }; rq.onerror=function(){ cb(null); }; }catch(e){ cb(null); } }); }
  /* guarda o diário por anúncio no IndexedDB + memória */
  function saveAdDaily(d){ _adDailyMem=d; try{ idbSet('adsdailyad_'+obj, {ts:Date.now(), d:d}); }catch(e){} _stFromAdDaily(); }
  /* carrega da IndexedDB p/ a memória (no início e ao trocar objetivo) */
  function loadAdDailyMem(cb){ idbGet('adsdailyad_'+obj, function(v){ _adDailyMem=(v&&v.d)||null; _stFromAdDaily(); if(cb)cb(); }); }
  function _stSet(id,veic){ if(id&&veic) _stMap[String(id)]=veic; }
  function _stVeic(r){ return _stMap[String(r.id)]||r.veiculacao; }
  function _stFromAdDaily(){ try{ var dd=_adDailyMem; if(!dd) return;
    (dd.ads||[]).forEach(function(m){ _stSet(m.id,m.status); }); (dd.adsets||[]).forEach(function(m){ _stSet(m.id,m.status); }); }catch(e){} }
  function colDef(k){ for(var i=0;i<ADCOLS.length;i++) if(ADCOLS[i].k===k) return ADCOLS[i]; return null; }
  var NA='<span class="mc-na">–</span>';
  function fmtCell(c,v){ if(c.f==='txt') return v?esc(String(v)):NA; if(v===''||v==null) return NA; if(c.f==='brl') return v?BRL(v):NA; if(c.f==='num') return v?NUM(v):NA; if(c.f==='pct') return v?PCT(v):NA; if(c.f==='mult') return v?(Number(v).toFixed(2).replace('.',',')+'x'):NA; if(c.f==='dec') return v?Number(v).toFixed(2).replace('.',','):NA; return esc(String(v)); }
  function activeCols(){ return adcols.order.filter(function(k){return adcols.sel[k];}).map(colDef).filter(Boolean); }
  /* ── item 9: abas CAMPANHAS / CONJUNTOS / ANÚNCIOS (estilo Gerenciador) ── */
  var tabLevel='campaign';
  var TAB_DEFS=[['campaign','Campanhas'],['adset','Conjuntos'],['ad','Anúncios']];
  function renderTblBc(){ var bc=$("#adp-tbl-bc"); if(!bc) return;
    bc.innerHTML='<div class="mc-lvltabs">'+TAB_DEFS.map(function(t){ var lv=t[0];
      var n=Object.keys(sel[lv]||{}).length;
      var badge=n?'<span class="mc-lvltab-sel"><b>'+n+'</b><span class="lvl-sel-txt"> selecionado'+(n>1?'s':'')+'</span><span class="mc-lvltab-x" data-clr="'+lv+'" title="Desmarcar">×</span></span>':'';
      var inlineCnt='<span class="lvl-cnt">'+(n?(' · '+n):'')+'</span>';
      return '<button type="button" class="mc-lvltab'+(tabLevel===lv?' on':'')+(n?' has-sel':'')+'" data-lv="'+lv+'">'+t[1]+inlineCnt+badge+'</button>';
    }).join('')+'</div>'; }
  function goTab(level){ tabLevel=level; mobPage=0; renderTblBc(); loadCurrentLevel(); }
  function loadCurrentLevel(){ if(tabLevel==='campaign') loadTable(null); else loadLevel(tabLevel); }
  function loadLevel(level){
    var myseq=++tblSeq, note=$("#adp-tbl-note");
    var campIds=Object.keys(sel.campaign).join(','), adsetIds=Object.keys(sel.adset).join(','), rng=apiRange(dateRange);
    var q={resource:"ads_level", level:level, range:rng};
    if(level==='adset'){ if(campIds) q.camp_ids=campIds; }
    else { if(adsetIds) q.adset_ids=adsetIds; else if(campIds) q.camp_ids=campIds; }
    var lsKey='mc_adlvl_'+level+'_'+rng+'_'+campIds+'_'+adsetIds;
    function apply(d){ if(myseq!==tblSeq) return; if(d&&d.error){ note.textContent='Erro: '+esc(d.error); tbl.rows=[]; renderTable(); return; } tbl.rows=(d&&d.rows)||[]; applyTableTax(tbl.rows); renderTable(); }
    var hadCache=false;
    // 1) cache exato dessa seleção
    try{ var s=localStorage.getItem(lsKey); if(s){ var cj=JSON.parse(s); if(cj&&cj.d){ hadCache=true; apply(cj.d); } } }catch(e){}
    // 2) senão, DERIVA da base completa baixada (sem seleção) filtrando por campanha/conjunto → instantâneo
    if(!hadCache && (campIds||adsetIds)){
      try{ var fs=localStorage.getItem('mc_adlvl_'+level+'_'+rng+'__');
        if(fs){ var fj=JSON.parse(fs), full=fj&&fj.d&&fj.d.rows;
          if(full){
            var campSet=campIds?campIds.split(','):[], adsetSet=adsetIds?adsetIds.split(','):[];
            var filt=full.filter(function(r){
              if(level==='adset') return campSet.indexOf(String(r.campaign_id))>=0;
              if(adsetSet.length) return adsetSet.indexOf(String(r.adset_id))>=0;
              if(campSet.length) return campSet.indexOf(String(r.campaign_id))>=0;
              return true;
            });
            apply({rows:filt}); hadCache=true;
          } } }catch(e){}
    }
    note.textContent='Carregando...'; note.style.display=hadCache?'none':'';
    if(hadCache && _rangeFresh(lsKey,rng) && !_rangeIncludesToday(rng)) return;
    call(q).then(function(d){ if(myseq!==tblSeq) return; if(d&&!d.error){ try{ localStorage.setItem(lsKey,JSON.stringify({ts:Date.now(),d:d})); }catch(e){} } apply(d); })
    .catch(function(e){ if(myseq!==tblSeq) return; if(!hadCache) note.textContent='Erro: '+esc(e.message); });
  }
  var COST1={custo_resultado:1,custo_lpv:1,custo_cart:1,custo_chk:1,custo_compra:1,cpm:1,cpc_link:1};
  var NEUTRAL={valor_usado:1,orcamento:1,frequencia:1};
  var TIPIDEAL={custo_cart:'cart',custo_chk:'chk',custo_compra:'cpa',custo_resultado:'cpa'};
  var NOTIP={nome:1,veiculacao:1,orcamento:1,utm:1};
  function rowMatch(r){ if(hideInactive&&String(r.veiculacao).indexOf('Ativo')<0) return false; if(search&&String(r.nome||'').toLowerCase().indexOf(search)<0) return false; return true; }
  function visRows(){ return tbl.rows.filter(rowMatch); }
  function colAvg(rows,k){ var s=0,n=0; rows.forEach(function(r){ var v=Number(r[k])||0; if(v>0){s+=v;n++;} }); return n?s/n:0; }
  function sortRows(){
    if(!sortKey) return;
    var c=colDef(sortKey);
    tbl.rows.sort(function(a,b){
      /* ativos sempre primeiro */
      var aA=String(a.veiculacao).indexOf('Ativo')>=0?0:1;
      var bA=String(b.veiculacao).indexOf('Ativo')>=0?0:1;
      if(aA!==bA) return aA-bA;
      /* veiculação: ordem cronológica (ativas primeiro, depois desativadas),
         mais recente primeiro — igual ao gerenciador de anúncios */
      if(sortKey==='veiculacao'){
        var ta=Date.parse(a.created_time||'')||0, tb=Date.parse(b.created_time||'')||0;
        return (tb-ta)*(sortDir<0?1:-1);
      }
      /* depois por sortKey */
      var x=a[sortKey],y=b[sortKey];
      if(c&&c.f==='txt'){ x=String(x||'').toLowerCase(); y=String(y||'').toLowerCase(); return x<y?-sortDir:x>y?sortDir:0; }
      x=Number(x)||0; y=Number(y)||0; return (x-y)*sortDir;
    });
  }
  function stColTd(v,ideal,mx){ if(!ideal||!v)return''; if(v<=ideal)return'is-good'; if(v<=mx)return''; return'is-bad'; }
  /* ── lista de campanhas no MOBILE: cards que expandem (sem scroll horizontal) ── */
  var MOBILE=window.matchMedia('(max-width:768px)');
  /* backdrop escuro+blur atrás do calendário no mobile (não cobre o próprio calendário) */
  var _calBackdrop=null;
  function calBackdrop_(on){
    if(on && MOBILE.matches){
      if(!_calBackdrop){ _calBackdrop=document.createElement('div'); _calBackdrop.className='mc-cal-backdrop'; root.appendChild(_calBackdrop); }
      _calBackdrop.style.display='block';
    } else if(_calBackdrop){ _calBackdrop.style.display='none'; }
  }
  function svgIc(path,color){ return '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="'+color+'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'+path+'</svg>'; }
  function mobCard(r){
    var lv=r.nivel, on=String(_stVeic(r)).indexOf('Ativo')>=0, checked=(sel[lv]&&sel[lv][r.id])?' checked':'';
    var roas=Number(r.roas)||0, roasStr=roas?roas.toFixed(2).replace('.',',')+'x':'-';
    var nextSt=on?'PAUSED':'ACTIVE';
    var toggle='<button class="mc-switch'+(on?' on':'')+'" type="button" role="switch" aria-checked="'+(on?'true':'false')+'" data-st-id="'+esc(r.id)+'" data-st-next="'+nextSt+'" title="'+(on?'Pausar na Meta':'Reativar na Meta')+'"><span class="mc-switch-knob"></span></button>';
    var cb='<input type="checkbox" class="rsel" data-id="'+esc(r.id)+'" data-lv="'+esc(lv)+'"'+checked+'>';
    function money(x){ return x?BRL(x):'–'; }
    function cell(v,l){ return '<div class="mc-mc-cell"><div class="v">'+v+'</div><div class="l">'+l+'</div></div>'; }
    var invGrid='<div class="mc-mc-grid">'+cell(money(r.valor_usado),'Valor usado')+cell(money(r.orcamento),'Orçamento')+cell(money(r.cpm),'CPM')+cell((r.frequencia?Number(r.frequencia).toFixed(2).replace('.',','):'–'),'Frequência')+'</div>';
    var reachGrid='<div class="mc-mc-grid">'+cell(NUM(r.alcance),'Alcance')+cell(NUM(r.cliques_link),'Cliques no link')+cell(r.ctr_link?PCT(r.ctr_link):'–','CTR')+cell(money(r.cpc_link),'CPC')+cell(NUM(r.lpv),'Visual. página')+cell(r.taxa_lpv?PCT(r.taxa_lpv):'–','Taxa visual.')+'</div>';
    function fnl(ico,color,bg,name,cost,count){ return '<div class="mc-mc-frow"><div class="mc-mc-fl"><div class="mc-mc-fic" style="background:'+bg+'">'+svgIc(ico,color)+'</div><div><div class="mc-mc-fn">'+name+'</div><div class="mc-mc-fc">'+cost+'</div></div></div><div class="mc-mc-fcount">'+count+'</div></div>'; }
    var funnel='<div class="mc-mc-funnel">'
      +fnl(ACQ_FUN_ICO.cart,'#5ac8fa','rgba(90,200,250,.15)','Carrinho', (r.custo_cart?BRL(r.custo_cart)+' por carrinho':'—'), NUM(r.total_cart))
      +fnl(ACQ_FUN_ICO.checkout,'#ff9f0a','rgba(255,159,10,.15)','Checkout',(r.custo_chk?BRL(r.custo_chk)+' por checkout':'—'), NUM(r.total_chk))
      +fnl(ACQ_FUN_ICO.check,'#34c759','rgba(52,199,89,.15)','Compras', (r.custo_compra?BRL(r.custo_compra)+' por compra':'—'), NUM(r.total_compra))
      +'</div>';
    var hero='<div class="mc-mc-hero"><div class="mc-mc-h roas"><div class="v">'+roasStr+'</div><div class="l">ROAS</div></div><div class="mc-mc-h"><div class="v">'+money(r.valor_conversao)+'</div><div class="l">Conversão</div></div><div class="mc-mc-h"><div class="v">'+money(r.valor_usado)+'</div><div class="l">Investido</div></div></div>';
    var fullNm='<div class="mc-mc-fullnm">'+(r.nome?esc(r.nome):'–')+'</div>';
    var statusRow='<div class="mc-mc-status"><span class="mc-mc-stlbl">'+(on?'Ativo':'Pausado')+'</span>'+toggle+'</div>';
    var body='<div class="mc-mc-body"><div class="mc-mc-inner">'+fullNm+statusRow+hero
      +'<div class="mc-mc-sect">Investimento</div>'+invGrid
      +'<div class="mc-mc-sect">Alcance & cliques</div>'+reachGrid
      +'<div class="mc-mc-sect">Funil de conversão</div>'+funnel
      +'<div class="mc-mc-foot">Custo por resultado · '+money(r.custo_resultado)+'</div>'
      +'</div></div>';
    var nmShort=String(r.nome||'–'); if(nmShort.length>16) nmShort=nmShort.slice(0,16)+'…';
    return '<div class="mc-mc'+(on?'':' off')+'" data-id="'+esc(r.id)+'" data-lv="'+esc(lv)+'">'
      +'<div class="mc-mc-row"><span class="mc-mc-dot'+(on?' on':'')+'"></span>'+cb+'<span class="mc-mc-nm">'+esc(nmShort)+'</span><span class="mc-mc-used">'+money(r.valor_usado)+'</span><span class="mc-mc-chev">▾</span></div>'
      +body+'</div>';
  }
  var mobPage=0, MOB_PER=12;
  function renderTableMobile(){
    var body=$("#adp-tbl-body"), note=$("#adp-tbl-note"), list=$("#adp-mob-list");
    if(body) body.innerHTML=''; var head=$("#adp-tbl-head"); if(head) head.innerHTML='';
    var m=$("#adp-tbl-more"); if(m) m.style.display='none';
    if(!list) return;
    var rows=visRows();
    if(!rows.length){ list.innerHTML=''; note.textContent=(search||hideInactive)?'Nada com esse filtro':'Sem dados no período'; note.style.display=''; return; }
    note.style.display='none';
    var pages=Math.ceil(rows.length/MOB_PER); if(mobPage>=pages) mobPage=0;
    var slice=rows.slice(mobPage*MOB_PER, mobPage*MOB_PER+MOB_PER);
    var html=slice.map(mobCard).join('');
    if(pages>1){
      html+='<div class="mc-mob-pg">'
        +'<button type="button" class="mc-mob-pgb" data-pg="prev"'+(mobPage===0?' disabled':'')+'>‹</button>'
        +'<span class="mc-mob-pgn">'+(mobPage+1)+' / '+pages+'</span>'
        +'<button type="button" class="mc-mob-pgb" data-pg="next"'+(mobPage>=pages-1?' disabled':'')+'>›</button>'
        +'</div>';
    }
    list.innerHTML=html;
  }
  function renderTable(){
    renderTblBc(); sortRows();
    if(MOBILE.matches){ renderTableMobile(); return; }
    var _ml=$("#adp-mob-list"); if(_ml) _ml.innerHTML='';
    /* pin: veiculacao(0), nome(1), valor_usado(2), resto dinâmico */
    var sel2=activeCols().filter(function(c){return c.k!=='veiculacao'&&c.k!=='nome'&&c.k!=='valor_usado';});
    var cols=[colDef('veiculacao'),colDef('nome'),colDef('valor_usado')].concat(sel2);
    var head=$("#adp-tbl-head"),body=$("#adp-tbl-body"),note=$("#adp-tbl-note");
    // checkbox "selecionar todos" no topo — marcada quando todas as visíveis já estão selecionadas
    var _vr=visRows(), _lv=_vr.length?_vr[0].nivel:null;
    var _allSel=!!(_lv&&_vr.length&&_vr.every(function(r){ return sel[_lv]&&sel[_lv][r.id]; }));
    head.innerHTML='<tr><th class="chk pin pin0"><input type="checkbox" class="rsel-all"'+(_allSel?' checked':'')+' title="Selecionar todos"></th>'+cols.map(function(c,ci){
      var pin=ci===0?' pin pin1':ci===1?' pin pin2':ci===2?' pin pin3':'';
      var ar=sortKey===c.k?(sortDir>0?' ▲':' ▼'):'';
      return '<th class="srt'+(c.f==='txt'?' lft':'')+pin+'" data-k="'+c.k+'">'+esc(c.t)+ar+'</th>';
    }).join("")+'</tr>';
    var rows=visRows();
    if(!rows.length){ body.innerHTML=''; note.textContent=(search||hideInactive)?'Nada com esse filtro':'Sem dados no período'; note.style.display=''; var m=$("#adp-tbl-more"); if(m) m.style.display='none'; return; }
    note.style.display='none';
    var tblMore=$("#adp-tbl-more"); if(tblMore) tblMore.style.display='none';
    // sem limite de linhas: mostra tudo e deixa o scroll vertical (max-height) cuidar
    var allRows=rows;
    var avg={}; cols.forEach(function(c){ if(!NOTIP[c.k]) avg[c.k]=colAvg(allRows,c.k); });
    body.innerHTML=rows.map(function(r){
      var lv=r.nivel,checked=(sel[lv]&&sel[lv][r.id])?' checked':'',on=String(_stVeic(r)).indexOf('Ativo')>=0;
      var dr=' class="'+(on?'row-on':'row-off')+(r.tem_filho?' drill':'')+'" data-id="'+esc(r.id)+'" data-lv="'+esc(lv)+'" data-nm="'+esc(r.nome)+'"';
      var cb='<td class="chk pin pin0"><input type="checkbox" class="rsel" data-id="'+esc(r.id)+'" data-lv="'+esc(lv)+'"'+checked+'></td>';
      return '<tr'+dr+'>'+cb+cols.map(function(c,ci){
        var v=r[c.k],cls=[];
        if(ci===0)cls.push('pin','pin1'); if(ci===1)cls.push('pin','pin2'); if(ci===2)cls.push('pin','pin3');
        if(c.f==='txt')cls.push('lft'); if(c.k==='utm')cls.push('clip');
        if(c.k==='veiculacao')cls.push('vc',(on?'vc-on':'vc-off'));
        var title=(c.f==='txt'&&v)?(' title="'+esc(String(v))+'"'):'',tip='';
        if(!NOTIP[c.k]){
          var lower=COST1[c.k]?'1':(NEUTRAL[c.k]?'n':'0'),idk=TIPIDEAL[c.k],idl=0,mxv=0;
          if(idk==='cart'){idl=metas.cart_ideal;mxv=metas.cart_max;}else if(idk==='chk'){idl=metas.chk_ideal;mxv=metas.chk_max;}else if(idk==='cpa'){idl=metas.cpa_ideal;mxv=metas.cpa_max;}
          var sc=stColTd(Number(v)||0,idl,mxv); if(sc)cls.push(sc);
          tip=' data-tt="1" data-name="'+esc(c.t)+'" data-val="'+(Number(v)||0)+'" data-media="'+(avg[c.k]||0)+'" data-ideal="'+(idl||0)+'" data-max="'+(mxv||0)+'" data-fmt="'+c.f+'" data-lower="'+lower+'"';
          if(c.k==='resultados'&&Number(r.naopago_ded)>0){
            var npd=Number(r.naopago_ded);
            tip+=' data-detail="Meta: '+NUM(Number(v)+npd)+'&#10;Deduzidos (n. pago): -'+NUM(npd)+'&#10;Líquido: '+NUM(Number(v))+'"';
          }
        }
        var cellHtml=fmtCell(c,v);
        if(c.k==='nome'){
          var thumb=(r.nivel==='ad')?(r.img?('<img class="mc-adthumb" src="'+esc(r.img)+'" loading="lazy" referrerpolicy="no-referrer" onerror="this.style.visibility=\'hidden\'">'):'<span class="mc-adthumb"></span>'):'';
          cellHtml='<div class="mc-nmwrap">'+thumb+'<span class="mc-nmtxt">'+(v?esc(String(v)):NA)+'</span></div>';
        }
        if(c.k==='veiculacao'){
          // slider on/off (igual à Meta): ligado à direita (amarelo) quando ativo, apagado à esquerda quando pausado
          var nextSt=on?'PAUSED':'ACTIVE';
          cellHtml='<button class="mc-switch'+(on?' on':'')+'" type="button" role="switch" aria-checked="'+(on?'true':'false')+'" data-st-id="'+esc(r.id)+'" data-st-next="'+nextSt+'" title="'+(on?'Pausar na Meta':'Reativar na Meta')+'"><span class="mc-switch-knob"></span></button>';
        }
        if(c.k==='orcamento' && (r.nivel==='campaign'||r.nivel==='adset') && Number(r.orcamento)>0){
          cellHtml+=' <button class="mc-bud-edit" type="button" data-bud-id="'+esc(r.id)+'" data-bud-lv="'+esc(r.nivel)+'" data-bud-val="'+(Number(r.orcamento)||0)+'" title="Alterar orçamento na Meta"><svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"></path><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"></path></svg></button>';
        }
        // tooltip só no VALOR (span), não na célula inteira
        var cellOut = tip ? '<span class="mc-cellv"'+tip+'>'+cellHtml+'</span>' : cellHtml;
        return '<td data-k="'+c.k+'"'+(cls.length?(' class="'+cls.join(' ')+'"'):'')+title+'>'+cellOut+'</td>';
      }).join("")+'</tr>';
    }).join("");
  }
  function loadTable(parent,plevel){
    var myseq=++tblSeq;
    var note=$("#adp-tbl-note");
    var q=parent?{resource:"ads_rows",parent:parent,parent_level:plevel,range:apiRange(dateRange)}:{resource:"ads_rows",objective:obj,range:apiRange(dateRange)};
    var lsKey='mc_adtbl_'+obj+'_'+apiRange(dateRange)+'_'+(parent||'')+'_'+(plevel||'');
    function applyTbl(d){
      if(d&&d.error){note.textContent='Erro: '+esc(d.error);tbl.rows=[];renderTable();return;}
      var rows=(d&&d.rows)||[];
      applyTableTax(rows); tbl.rows=rows;
      if(tabLevel==='campaign'){
        npDedTotal=rows.reduce(function(s,r){return s+(Number(r.naopago_ded)||0);},0); renderChips();
        // taxa média de "visual. página" dos itens ATIVOS (ponderada: lpv/cliques no link)
        var aClk=0,aLpv=0;
        rows.forEach(function(r){ if(String(r.veiculacao).indexOf('Ativo')<0) return; aClk+=Number(r.cliques_link)||0; aLpv+=Number(r.lpv)||0; });
        tblLpvRate=aClk>0?Math.min(1,aLpv/aClk):null;
        if(viewMode==='funil') renderFunnel(); else if(viewMode==='eventos') renderEventos();
      }
      renderTable();
    }
    /* stale-while-revalidate: mostra o cache na hora e revalida ao fundo */
    var hadCache=false;
    // drill instantâneo: deriva conjuntos/anúncios do diário por anúncio (se disponível)
    if(parent){ var _der=deriveTableFromDaily_(parent, plevel, apiRange(dateRange)); if(_der){ hadCache=true; applyTbl(_der); } }
    if(!hadCache) try{ var s=localStorage.getItem(lsKey); if(s){ var cj=JSON.parse(s); if(cj&&cj.d){ hadCache=true; applyTbl(cj.d); } } }catch(e){}
    note.textContent='Carregando...'; note.style.display=hadCache?'none':'';
    // período passado com cache válido: não re-busca (instantâneo)
    if(hadCache && _rangeFresh(lsKey, apiRange(dateRange)) && !_rangeIncludesToday(apiRange(dateRange))) return;
    call(q).then(function(d){ if(myseq!==tblSeq) return; if(d&&!d.error){ (d.rows||[]).forEach(function(r){ _stSet(r.id, r.veiculacao); }); try{ localStorage.setItem(lsKey,JSON.stringify({ts:Date.now(),d:d})); }catch(e){} } applyTbl(d); })
    .catch(function(e){ if(myseq!==tblSeq) return; if(!hadCache) note.textContent='Erro: '+esc(e.message); });
  }
  function loadTableRoot(){ tbl.stack=[]; tbl._showAll=false; tabLevel='campaign'; renderTblBc(); loadTable(null); }
  function tblDrill(id,lv,nm){ tbl.stack.push({id:id,level:lv,nome:nm}); loadTable(id,lv); }
  function tblGoto(i){ if(i<0){loadTableRoot();return;} tbl.stack=tbl.stack.slice(0,i+1); var s=tbl.stack[i]; loadTable(s.id,s.level); }

  /* ── column panel com drag-and-drop ── */
  var dragSrcK=null;
  function renderColPanel(){
    var panel=$("#adp-col-panel");
    panel.innerHTML=
      adcols.order.map(function(k){
        var c=colDef(k); if(!c) return '';
        var isFixed=!!c.fixed;
        return '<div class="mc-colrow"'+(isFixed?'':' draggable="true"')+' data-k="'+k+'">'+
          '<label><input type="checkbox" data-k="'+k+'"'+(adcols.sel[k]?' checked':'')+(isFixed?' disabled':'')+'>'+esc(c.t)+'</label>'+
          '</div>';
      }).join("")+
      '<div class="mc-colpick-foot"><button class="mc-tool-item" id="adp-col-save" type="button">Salvar predefinição</button></div>';
    /* attach drag events */
    panel.querySelectorAll('.mc-colrow[draggable]').forEach(function(row){
      row.addEventListener('dragstart',function(e){
        dragSrcK=this.getAttribute('data-k');
        e.dataTransfer.effectAllowed='move';
        this.style.opacity='0.4';
      });
      row.addEventListener('dragend',function(){
        this.style.opacity='';
        panel.querySelectorAll('.drag-over').forEach(function(r){r.classList.remove('drag-over');});
      });
      row.addEventListener('dragover',function(e){
        e.preventDefault(); e.dataTransfer.dropEffect='move';
        panel.querySelectorAll('.drag-over').forEach(function(r){r.classList.remove('drag-over');});
        this.classList.add('drag-over');
      });
      row.addEventListener('dragleave',function(){ this.classList.remove('drag-over'); });
      row.addEventListener('drop',function(e){
        e.preventDefault();
        var tgt=this.getAttribute('data-k');
        if(!dragSrcK||dragSrcK===tgt) return;
        var o=adcols.order.slice(),si=o.indexOf(dragSrcK),ti=o.indexOf(tgt);
        if(si<0||ti<0) return;
        o.splice(si,1); o.splice(ti,0,dragSrcK);
        adcols.order=o; saveAdCols(); renderColPanel(); renderTable();
      });
    });
  }
  $("#adp-col-btn").addEventListener("click",function(){ $("#adp-colwrap").classList.toggle("open"); renderColPanel(); });
  $("#adp-col-panel").addEventListener("change",function(ev){ var cb=ev.target; if(!cb||cb.type!=="checkbox")return; adcols.sel[cb.getAttribute("data-k")]=cb.checked; saveAdCols(); renderTable(); });
  /* salvar predefinição (botão fixo no rodapé do painel de colunas) */
  $("#adp-col-panel").addEventListener("click",function(ev){ if(ev.target.closest("#adp-col-save")) savePresetFlow(); });

  /* ── predefinições de colunas (nome + colunas ativas/ordem, salvas na base) ── */
  var colPresets=[], presetName='', _presetApplied=false;
  function updatePresetBtn(){ var b=$("#adp-preset-btn"); if(b) b.innerHTML='<span class="mc-dd-ic"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="21" x2="4" y2="14"></line><line x1="4" y1="10" x2="4" y2="3"></line><line x1="12" y1="21" x2="12" y2="12"></line><line x1="12" y1="8" x2="12" y2="3"></line><line x1="20" y1="21" x2="20" y2="16"></line><line x1="20" y1="12" x2="20" y2="3"></line><line x1="1" y1="14" x2="7" y2="14"></line><line x1="9" y1="8" x2="15" y2="8"></line><line x1="17" y1="16" x2="23" y2="16"></line></svg></span><span class="mc-dd-lbl">'+(presetName?esc(presetName):'Predefinições')+'</span><span class="mc-dd-caret"><svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg></span>'; }
  function renderPresetPanel(){
    var panel=$("#adp-preset-panel"); if(!panel) return;
    if(!colPresets.length){ panel.innerHTML='<div class="mc-preset-empty">Nenhuma predefinição salva</div>'; return; }
    panel.innerHTML=colPresets.map(function(p){
      return '<div class="mc-preset-row'+(p.name===presetName?' is-active':'')+'" data-nm="'+esc(p.name)+'"><span class="nm">'+esc(p.name)+'</span><span class="del" data-del="'+esc(p.name)+'" title="Excluir">×</span></div>';
    }).join('');
  }
  function applyPreset(p){
    if(!p) return;
    try{ var c=JSON.parse(p.cols); if(c&&c.order&&c.sel){ c.sel['veiculacao']=true; c.sel['nome']=true; c.sel['valor_usado']=true; adcols={order:c.order.slice(), sel:c.sel}; saveAdCols(); renderColPanel(); renderTable(); } }catch(e){}
    presetName=p.name; updatePresetBtn(); renderPresetPanel();
  }
  function loadColPresets(){
    call({resource:"col_presets_get"}).then(function(d){
      colPresets=(d&&d.rows)||[];
      if(colPresets.length && !_presetApplied){ _presetApplied=true; applyPreset(colPresets[0]); }
      renderPresetPanel(); updatePresetBtn();
    }).catch(function(){});
  }
  function savePresetFlow(){
    mcPrompt("Salvar predefinição de colunas","Nome da predefinição",presetName||"").then(function(name){
      if(!name) return;
      call({resource:"col_presets_save", name:name, cols:JSON.stringify(adcols)}).then(function(d){
        if(d&&d.ok){ colPresets=d.rows||colPresets; presetName=name; renderPresetPanel(); updatePresetBtn(); $("#adp-colwrap").classList.remove("open"); }
        else alert("Erro ao salvar: "+((d&&d.error)||"desconhecido"));
      }).catch(function(e){ alert("Erro: "+e.message); });
    });
  }
  $("#adp-preset-btn").addEventListener("click",function(){ $("#adp-presetwrap").classList.toggle("open"); renderPresetPanel(); });
  $("#adp-preset-panel").addEventListener("click",function(ev){
    var del=ev.target.closest("[data-del]");
    if(del){ ev.stopPropagation(); var dn=del.getAttribute("data-del");
      mcConfirm("Excluir a predefinição \""+dn+"\"?","Excluir").then(function(ok){ if(!ok) return;
        call({resource:"col_presets_delete", name:dn}).then(function(d){ if(d&&d.ok){ colPresets=d.rows||[]; if(presetName===dn) presetName=''; renderPresetPanel(); updatePresetBtn(); } }); });
      return; }
    var row=ev.target.closest(".mc-preset-row"); if(!row) return;
    var nm=row.getAttribute("data-nm");
    var p=colPresets.filter(function(x){return x.name===nm;})[0];
    if(p){ applyPreset(p); $("#adp-presetwrap").classList.remove("open"); }
  });
  loadColPresets();
  $("#adp-tbl-bc").addEventListener("click",function(ev){
    var x=ev.target.closest(".mc-lvltab-x");
    if(x){ ev.stopPropagation(); var clv=x.getAttribute("data-clr"); sel[clv]={}; updateSelInfo(); renderTblBc(); loadCurrentLevel(); selChanged(); return; }
    var b=ev.target.closest(".mc-lvltab"); if(b) goTab(b.getAttribute("data-lv"));
  });
  (function(){ var m=$("#adp-tbl-more"); if(m) m.addEventListener("click",function(){ tbl._showAll=true; renderTable(); }); })();
  $("#adp-tbl-body").addEventListener("click",function(ev){ if(ev.target.closest(".chk")||ev.target.closest(".mc-switch")||ev.target.closest(".mc-bud-edit"))return;
    var tr=ev.target.closest("tr.drill"); if(!tr) return;
    var id=tr.getAttribute("data-id"), lv=tr.getAttribute("data-lv");
    // clicar numa campanha abre os CONJUNTOS dela; num conjunto abre os ANÚNCIOS dele
    var target;
    if(lv==='campaign'){ sel={campaign:{},adset:{},ad:{}}; sel.campaign[id]=1; target='adset'; }
    else if(lv==='adset'){ sel.adset={}; sel.ad={}; sel.adset[id]=1; target='ad'; } // mantém a campanha selecionada
    else return;
    updateSelInfo(); selChanged(); goTab(target);
  });
  /* pausar / reativar campanha-conjunto-anúncio direto na Meta */
  /* nº de alterações de status em andamento na Meta — pra avisar se o usuário fechar a aba */
  var _stPending=0;
  window.addEventListener('beforeunload',function(e){ if(_stPending>0){ e.preventDefault(); e.returnValue='Ainda estamos salvando alterações na Meta. Deseja mesmo sair?'; return e.returnValue; } });
  $("#adp-tbl-body").addEventListener("click",function(ev){
    var b=ev.target.closest(".mc-switch"); if(!b) return;
    ev.stopPropagation();
    if(b.disabled) return;
    var id=b.getAttribute("data-st-id"), next=b.getAttribute("data-st-next");
    if(!id) return;
    var paused = next==='PAUSED';
    // ── atualização OTIMISTA imediata (sem janela de confirmação) ──
    function setUi(pausedState){
      b.classList.toggle('on',!pausedState);
      b.setAttribute('aria-checked', pausedState?'false':'true');
      b.setAttribute('data-st-next', pausedState ? 'ACTIVE' : 'PAUSED');
      b.title = pausedState ? 'Reativar na Meta' : 'Pausar na Meta';
      var td=b.closest('td');
      if(td){ td.classList.toggle('vc-on',!pausedState); td.classList.toggle('vc-off',pausedState);
        var tr=b.closest('tr'); if(tr){ tr.classList.toggle('row-on',!pausedState); tr.classList.toggle('row-off',pausedState); } }
    }
    setUi(paused);
    b.classList.add('mc-switch-loading');
    _stPending++;
    call({resource:"meta_set_status", id:id, status:next}).then(function(d){
      _stPending=Math.max(0,_stPending-1);
      b.classList.remove('mc-switch-loading');
      if(d&&d.ok){ setTimeout(function(){ reloadTable(); load(); }, 1500); }
      else { setUi(!paused); alert('Erro ao atualizar na Meta: '+((d&&d.error)||'desconhecido')); }
    }).catch(function(e){ _stPending=Math.max(0,_stPending-1); b.classList.remove('mc-switch-loading'); setUi(!paused); alert('Erro: '+e.message); });
  });
  /* alterar orçamento inline: clica no lápis → vira um campo no próprio lugar do valor */
  function budgetEdit(b){
    var td=b.closest('td'); if(!td || td.querySelector('.mc-bud-input')) return;
    var id=b.getAttribute('data-bud-id'), cur=Number(b.getAttribute('data-bud-val'))||0;
    var prevHtml=td.innerHTML;
    td.innerHTML='<span class="mc-bud-wrap"><input class="mc-bud-input" type="text" inputmode="decimal" value="'+(cur?BRL(cur).replace('R$','').trim():'')+'">'+
      '<button class="mc-bud-ok" type="button" title="Salvar">✓</button>'+
      '<button class="mc-bud-x" type="button" title="Cancelar">✕</button></span>';
    var inp=td.querySelector('.mc-bud-input');
    inp.focus(); inp.select();
    function restore(){ td.innerHTML=prevHtml; }
    function save(){
      var raw=String(inp.value).trim().replace(/\s|R\$/g,'');
      var val = raw.indexOf(',')>=0 ? parseFloat(raw.replace(/\./g,'').replace(',','.')) : parseFloat(raw);
      if(!(val>0)){ inp.classList.add('mc-bud-err'); inp.focus(); return; }
      if(val===cur){ restore(); return; }
      inp.disabled=true; var ok=td.querySelector('.mc-bud-ok'); if(ok) ok.textContent='…';
      call({resource:'meta_set_budget', id:id, budget:val}).then(function(d){
        if(d&&d.ok){ td.innerHTML=BRL(val); setTimeout(function(){ reloadTable(); load(); },1200); }
        else { alert('Erro ao alterar orçamento: '+((d&&d.error)||'desconhecido')); restore(); }
      }).catch(function(e){ alert('Erro: '+e.message); restore(); });
    }
    inp.addEventListener('keydown',function(e){ if(e.key==='Enter'){ e.preventDefault(); save(); } else if(e.key==='Escape'){ e.preventDefault(); restore(); } });
    inp.addEventListener('input',function(){ inp.classList.remove('mc-bud-err'); });
    td.querySelector('.mc-bud-ok').addEventListener('click',save);
    td.querySelector('.mc-bud-x').addEventListener('click',restore);
  }
  $("#adp-tbl-body").addEventListener("click",function(ev){
    var b=ev.target.closest(".mc-bud-edit"); if(!b) return;
    ev.stopPropagation();
    budgetEdit(b);
  });
  $("#adp-tbl-body").addEventListener("change",function(ev){ var cb=ev.target.closest(".rsel"); if(!cb)return; var lv=cb.getAttribute("data-lv"),id=cb.getAttribute("data-id"); if(cb.checked) sel[lv][id]=1; else delete sel[lv][id]; renderTblBc(); selChanged(); });
  /* ── listeners da lista MOBILE (cards) ── */
  (function(){ var ml=$("#adp-mob-list"); if(!ml) return;
    // paginação
    ml.addEventListener("click",function(ev){ var pb=ev.target.closest(".mc-mob-pgb"); if(!pb||pb.disabled) return;
      mobPage += (pb.getAttribute("data-pg")==="next"?1:-1); if(mobPage<0) mobPage=0;
      renderTableMobile();
      var wrap=$("#adp-tablewrap"); if(wrap) wrap.scrollIntoView({behavior:"smooth",block:"start"});
    });
    // expandir/recolher ao tocar na linha — máximo 1 card aberto por vez (item 9)
    ml.addEventListener("click",function(ev){
      if(ev.target.closest(".rsel")||ev.target.closest(".mc-switch")||ev.target.closest(".mc-mob-pgb")) return;
      var card=ev.target.closest(".mc-mc"); if(!card) return;
      var willOpen=!card.classList.contains("open");
      Array.prototype.forEach.call(ml.querySelectorAll(".mc-mc.open"),function(c){ c.classList.remove("open"); });
      if(willOpen) card.classList.add("open");
    });
    // checkbox de seleção
    ml.addEventListener("change",function(ev){ var cb=ev.target.closest(".rsel"); if(!cb) return;
      var lv=cb.getAttribute("data-lv"), id=cb.getAttribute("data-id");
      if(cb.checked) sel[lv][id]=1; else delete sel[lv][id];
      renderTblBc(); selChanged();
    });
    // toggle ativar/pausar na Meta (UI otimista no card)
    ml.addEventListener("click",function(ev){ var b=ev.target.closest(".mc-switch"); if(!b) return;
      ev.stopPropagation(); if(b.disabled) return;
      var id=b.getAttribute("data-st-id"), next=b.getAttribute("data-st-next"), paused=next==='PAUSED';
      function setUi(ps){ b.classList.toggle('on',!ps); b.setAttribute('aria-checked',ps?'false':'true'); b.setAttribute('data-st-next',ps?'ACTIVE':'PAUSED'); var card=b.closest('.mc-mc'); if(card) card.classList.toggle('off',ps); }
      setUi(paused); b.classList.add('mc-switch-loading'); _stPending++;
      call({resource:"meta_set_status", id:id, status:next}).then(function(d){ _stPending=Math.max(0,_stPending-1); b.classList.remove('mc-switch-loading');
        if(d&&d.ok){ setTimeout(function(){ reloadTable(); load(); },1500); } else { setUi(!paused); alert('Erro ao atualizar na Meta: '+((d&&d.error)||'desconhecido')); }
      }).catch(function(e){ _stPending=Math.max(0,_stPending-1); b.classList.remove('mc-switch-loading'); setUi(!paused); alert('Erro: '+e.message); });
    });
  })();
  // re-renderiza ao cruzar o breakpoint mobile/desktop
  (function(){ function onCh(){ renderTable(); } if(MOBILE.addEventListener) MOBILE.addEventListener('change',onCh); else if(MOBILE.addListener) MOBILE.addListener(onCh); })();
  (function(){ var _sc=$("#adp-sel-clear"); if(_sc) _sc.addEventListener("click",function(){ sel={campaign:{},adset:{},ad:{}}; updateSelInfo(); renderTable(); bestPage=0; load(); }); })();
  /* botão direito numa célula de Carrinho/Checkout/Resultado → menu "Editar dedução" */
  $("#adp-tbl-body").addEventListener("contextmenu",function(ev){
    var td=ev.target.closest("td"); if(!td) return;
    var k=td.getAttribute("data-k"); if(!ADJ_METRIC[k]) return;
    var tr=td.closest("tr"); if(!tr) return;
    ev.preventDefault(); closeAdjMenu();
    var id=tr.getAttribute("data-id"), lv=tr.getAttribute("data-lv"), nm=tr.getAttribute("data-nm");
    var rowObj=(tbl.rows||[]).filter(function(x){return String(x.id)===String(id);})[0]||{};
    var totalVal=Number(rowObj[k])||0;
    var m=document.createElement("div"); m.className="mc-adjmenu";
    m.innerHTML='<button type="button"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"></path><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"></path></svg>Editar dedução · '+esc(ADJ_METRIC[k][1])+'</button>';
    document.body.appendChild(m);
    m.style.left=Math.min(ev.clientX, window.innerWidth-190)+"px"; m.style.top=Math.min(ev.clientY, window.innerHeight-60)+"px";
    m.querySelector("button").addEventListener("click",function(){ closeAdjMenu(); adjEdit(id, lv, nm, k, totalVal); });
    _adjMenu=m;
  });
  document.addEventListener("click",closeAdjMenu);
  document.addEventListener("contextmenu",function(e){ if(!e.target.closest("#adp-tbl-body td")) closeAdjMenu(); });
  $("#adp-tbl-head").addEventListener("click",function(ev){ if(ev.target.closest(".rsel-all"))return; var th=ev.target.closest("th[data-k]"); if(!th)return; var k=th.getAttribute("data-k"); if(sortKey===k) sortDir=-sortDir; else{sortKey=k;sortDir=-1;} renderTable(); });
  /* selecionar/desselecionar todas as visíveis pelo checkbox do topo */
  $("#adp-tbl-head").addEventListener("change",function(ev){ var cb=ev.target.closest(".rsel-all"); if(!cb) return;
    var rows=visRows(); if(!rows.length) return; var lv=rows[0].nivel;
    rows.forEach(function(r){ if(cb.checked) sel[lv][r.id]=1; else delete sel[lv][r.id]; });
    updateSelInfo(); renderTblBc(); renderTable(); selChanged();
  });
  var _searchT; $("#adp-search").addEventListener("input",function(){ var v=this.value.toLowerCase(); clearTimeout(_searchT); _searchT=setTimeout(function(){ search=v; bestPage=0; mobPage=0; renderTable(); renderBest(); },200); });
  (function(){
    var eyeOpen='<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>';
    var eyeOff='<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"></path><path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>';
    var btn=$("#adp-inactive");
    btn.style.alignItems='center'; btn.style.justifyContent='center'; btn.style.display='inline-flex';
    btn.innerHTML=eyeOpen; btn.title='Ocultar inativos'; btn.classList.add('mc-eye-btn');
    btn.addEventListener("click",function(){
      hideInactive=!hideInactive;
      btn.innerHTML=(hideInactive?eyeOff:eyeOpen);
      btn.title=hideInactive?'Mostrar inativos':'Ocultar inativos';
      btn.classList.toggle('active',hideInactive);
      renderTable();
      // re-renderiza KPIs/chips/funil/ranking pra refletir o filtro de inativos
      renderKpis(curEnts()); renderCurrentView(); renderChips(); renderBest();
    });
  })();
  /* ── hover: prévia grande da mídia ORIGINAL (1080x1920) do anúncio ── */
  (function(){
    var imgMap={}; // id → img (ranking/best)
    function rebuildImgMap(){ imgMap={}; best.forEach(function(a){ if(a.img) imgMap[a.id]=a.img; }); }
    var W=132,H=234; // 9:16, menor
    var tblImgTip=document.createElement("div");
    tblImgTip.style.cssText="display:none;position:fixed;z-index:9999;pointer-events:none;background:#000;border:1px solid rgba(255,255,255,0.14);overflow:hidden;width:"+W+"px;height:"+H+"px;box-shadow:0 10px 30px rgba(0,0,0,0.7);";
    document.body.appendChild(tblImgTip);
    var tblImgEl=document.createElement("img");
    tblImgEl.style.cssText="display:block;width:100%;height:100%;object-fit:contain;background:#000;";
    tblImgTip.appendChild(tblImgEl);
    var tblBody=$("#adp-tbl-body");
    function hide(){ tblImgTip.style.display="none"; }
    var hiCache={}; // id → mídia ORIGINAL (1080x1920) via ad_thumb/metaThumb_
    function fetchHi(id){
      if(hiCache[id]!==undefined) return; hiCache[id]=null;
      call({resource:"ad_thumb", ad_id:id}).then(function(d){
        var u=(d&&d.thumbnail_url)||''; if(!u){ hiCache[id]=''; return; }
        // só troca se a original realmente carregar (evita quadro preto de URL quebrada)
        var pre=new Image();
        pre.onload=function(){ hiCache[id]=u; if(tblImgTip.style.display!=="none" && tblImgTip.getAttribute("data-id")===id) tblImgEl.src=u; };
        pre.onerror=function(){ hiCache[id]=''; };
        pre.src=u;
      }).catch(function(){ hiCache[id]=''; });
    }
    if(tblBody){
      tblBody.addEventListener("mouseover",function(ev){
        // só dispara com o mouse EXATAMENTE em cima da miniatura
        var thumbEl=ev.target.closest(".mc-adthumb"); if(!thumbEl){ return; }
        var tr=thumbEl.closest("tr[data-lv='ad']"); if(!tr) return;
        var id=tr.getAttribute("data-id"); if(!id) return;
        if(!Object.keys(imgMap).length) rebuildImgMap();
        // mostra a original em alta quando já temos; senão a miniatura, e busca a original ao fundo
        var src=hiCache[id]||imgMap[id]||thumbEl.getAttribute("src")||"";
        if(!src){ hide(); return; }
        tblImgTip.setAttribute("data-id",id);
        tblImgEl.src=src; tblImgTip.style.display="block";
        if(!hiCache[id]) fetchHi(id);
      });
      tblBody.addEventListener("mousemove",function(ev){
        if(tblImgTip.style.display==="none") return;
        if(!ev.target.closest(".mc-adthumb")){ hide(); return; }
        var x=ev.clientX+16, y=ev.clientY-H/2;
        if(x+W+8>window.innerWidth) x=ev.clientX-W-16;
        if(y<4) y=4; if(y+H+4>window.innerHeight) y=window.innerHeight-H-4;
        tblImgTip.style.left=x+"px"; tblImgTip.style.top=y+"px";
      });
      tblBody.addEventListener("mouseleave",hide);
      var _sc=root.querySelector(".mc-tbl-scroll"); if(_sc) _sc.addEventListener("mouseleave",hide);
    }
    var _origLoad=load;
    load=function(){ _origLoad(); setTimeout(rebuildImgMap,2000); };
  })();

  /* ── sugestões ── */
  function arrows(n,up){ var s=''; for(var i=0;i<n;i++) s+=up?'▲':'▼'; return s; }
  function renderSug(d){
    var box=$("#adp-sug"),s=(d&&d.sugestoes)||[];
    if(!s.length){ box.innerHTML='<p class="mc-empty">Nenhuma janela de performance clara ainda (precisa de 2+ dias com gasto ou ter gasto o CPA ideal).</p>'; return; }
    box.innerHTML=s.map(function(x){ var up=x.tipo==='duplicar';
      var stats='<div class="sg-stats"><span>Gasto<b>'+BRL(x.spend)+'</b></span><span>CPA<b>'+(x.cpa?BRL(x.cpa):'-')+'</b></span><span>Dias<b>'+x.dias+'</b></span><span>Carrinhos<b>'+NUM(x.carrinhos)+'</b></span><span>Compras<b>'+NUM(x.compras)+'</b></span></div>';
      return '<div class="mc-sugcard '+(up?'good':'bad')+'"><div class="sg-h"><span class="arrows">'+arrows(x.nivel||1,up)+'</span><span class="tag">'+(up?'Escalar':'Desligar')+'</span><span class="nm">'+esc(x.nome)+'</span><span class="ch">+</span></div><div class="sg-b"><span class="cp">'+esc(x.campanha)+'</span>'+stats+'<p class="ms">'+esc(x.motivo)+'</p></div></div>';
    }).join("");
  }
  function loadSug(){ var box=$("#adp-sug"); box.innerHTML='<p class="mc-empty">Analisando...</p>'; var s2=selParams(); call({resource:"ads_suggest",objective:obj,camp_ids:s2.camp_ids,adset_ids:s2.adset_ids,ad_ids:s2.ad_ids,range:dateRange}).then(function(d){ if(d&&d.error){box.innerHTML='<p class="mc-empty">Erro: '+esc(d.error)+'</p>';return;} renderSug(d); }).catch(function(e){ box.innerHTML='<p class="mc-empty">Erro: '+esc(e.message)+'</p>'; }); }

  /* ── insights gerais ── */
  function fmtMetric(v,fmt){ if(fmt==='brl')return BRL(v); if(fmt==='pct')return PCT(v); return NUM(Math.round(v)); }
  var _insData=[],_insIdx=0,_insDias=0;
  var TREND_ICONS={'CPA':'◎','ROAS':'◈','CPM':'◉','CTR':'◐','CPC':'◆','Ticket':'◇','Carrinho':'▣','Checkout':'▤','Gasto':'▲','Frequen':'↺','Compra':'✔'};
  function trendIc(m){ for(var k in TREND_ICONS) if(m.indexOf(k)>=0) return TREND_ICONS[k]; return '◈'; }
  function renderInsCard(){
    var box=$("#adp-ins"); if(!box) return;
    var s=_insData,n=s.length;
    if(!n){ box.innerHTML=''; return; }
    if(_insIdx<0)_insIdx=n-1; if(_insIdx>=n)_insIdx=0;
    var x=s[_insIdx],up=x.direcao==='subiu';
    box.innerHTML=
      '<div class="mc-ins-caro">'+
      (n>1?'<button class="mc-ins-nav" id="adp-ins-prev">&lsaquo;</button>':'')+
      '<div class="mc-inscard '+x.tom+'">'+
        '<span class="mc-ins-icon">'+trendIc(x.metrica)+'</span>'+
        '<span class="mc-ins-met">'+esc(x.metrica)+'</span>'+
        '<span class="mc-ins-val '+(up?'is-good':'is-bad')+'">'+(up?'+':'')+PCT(Math.abs(x.variacao))+'</span>'+
        '<span class="mc-ins-now">agora '+fmtMetric(x.atual,x.fmt)+'</span>'+
        '<span class="mc-ins-sub">ult. '+_insDias+' dias</span>'+
      '</div>'+
      (n>1?'<button class="mc-ins-nav" id="adp-ins-next">&rsaquo;</button>':'')+
      (n>1?'<span class="mc-ins-pg">'+(_insIdx+1)+'/'+n+'</span>':'')+
      '</div>';
    var prev=box.querySelector('#adp-ins-prev'),next=box.querySelector('#adp-ins-next');
    if(prev) prev.addEventListener('click',function(){_insIdx--;renderInsCard();});
    if(next) next.addEventListener('click',function(){_insIdx++;renderInsCard();});
  }
  function renderTrends(d){
    var box=$("#adp-ins"),s=(d&&d.insights)||[],n=(d&&d.dias)||0;
    if(!box) return;
    if(!s.length){ box.innerHTML='<p class="mc-empty">'+(n<4?'Poucos dias para detectar tendencias.':'Nenhuma variacao relevante nos ultimos '+n+' dias.')+'</p>'; return; }
    _insData=s; _insDias=n; _insIdx=0; renderInsCard();
  }
  function loadTrends(){ var box=$("#adp-ins"); if(!box) return; box.innerHTML='<p class="mc-empty">Analisando tendências...</p>'; var s2=selParams(); call({resource:"ads_trends",objective:obj,camp_ids:s2.camp_ids,adset_ids:s2.adset_ids,ad_ids:s2.ad_ids}).then(function(d){ if(d&&d.error){box.innerHTML='<p class="mc-empty">Erro: '+esc(d.error)+'</p>';return;} renderTrends(d); }).catch(function(e){ box.innerHTML='<p class="mc-empty">Erro: '+esc(e.message)+'</p>'; }); }

  /* ── carga principal ── */
  function applyAdsData(d){ applyMetaTax(d); ents=(d&&d.entidades)||[]; best=(d&&d.melhores)||[]; metas=(d&&d.metas)||{}; media=(d&&d.media)||{}; kpiPrev=(d&&d.kpi_prev)||null; cancelados=(d&&d.cancelados)||{count:0,valor:0}; custosTrafico=(d&&d.custos_trafego)||{}; margemOp=(d&&d.margem_op)||{}; bestPage=0; try{ render(); }catch(e){} acqSetLoading(false); if(tbl.rows&&tbl.rows.length){ try{ renderTable(); }catch(e){} } }
  /* deriva KPIs/chips/funil de uma seleção filtrando as entidades da base baixada (instantâneo) */
  function deriveSelDeep_(base, s2){
    var ents0=(base.entidades||[]), f=ents0;
    if(s2.ad_ids){ var A=s2.ad_ids.split(','); f=ents0.filter(function(e){ return A.indexOf(String(e.id))>=0; }); }
    else if(s2.adset_ids){ var S=s2.adset_ids.split(','); f=ents0.filter(function(e){ return S.indexOf(String(e.adset_id))>=0; }); }
    else if(s2.camp_ids){ var C=s2.camp_ids.split(','); f=ents0.filter(function(e){ return C.indexOf(String(e.campaign_id))>=0; }); }
    var out={}; for(var k in base) out[k]=base[k]; out.entidades=f; return out;
  }
  /* período longo (6m/ano/máximo/custom grande)? */
  function isLongFront_(rng){
    rng=String(rng||'');
    if(rng==='6m'||rng==='ano'||rng==='max') return true;
    if(rng.indexOf('~')>0){ var p=rng.split('~'); var a=new Date(p[0]+'T00:00:00'), b=new Date(p[1]+'T00:00:00'); return (b-a)>62*864e5; }
    return false;
  }
  /* deriva KPIs/funil/chips do diário por campanha (evita o ads_deep pesado em períodos longos) */
  function deepFromDaily_(rng, campIds){
    try{
      var c=localStorage.getItem('mc_adsdaily_'+obj); if(!c) return null;
      var j=JSON.parse(c), dd=j&&j.d; if(!dd||!dd.rows) return null;
      var filt=campIds?String(campIds).split(',').filter(Boolean):null;
      var win=acqRangeISO_(rng), byC={};
      dd.rows.forEach(function(r){ if(r.d<win.a||r.d>win.b) return; if(filt && filt.indexOf(String(r.c))<0) return;
        var o=byC[r.c]||(byC[r.c]={spend:0,impr:0,clk:0,cart:0,chk:0,pur:0,val:0,lpv:0});
        o.spend+=r.s||0;o.impr+=r.im||0;o.clk+=r.ck||0;o.cart+=r.ca||0;o.chk+=r.ch||0;o.pur+=r.pu||0;o.val+=r.vl||0;o.lpv+=r.lp||0;
      });
      var meta={}; (dd.campaigns||[]).forEach(function(m){ meta[m.id]=m; });
      var ents0=Object.keys(byC).map(function(cid){ var o=byC[cid], m=meta[cid]||{};
        return { id:cid, nome:m.nome||cid, campanha:m.nome||cid, conjunto:'', campaign_id:cid, adset_id:'',
          spend:o.spend, reach:0, impressions:o.impr, clicks:o.clk, lpv:o.lpv, carrinho:o.cart, checkout:o.chk,
          resultados:o.pur, conversao_valor:o.val, ativo:(String(m.status||'').toLowerCase().indexOf('ativ')>=0),
          ctr:o.impr?o.clk/o.impr:0, cpc:o.clk?o.spend/o.clk:0, cpm:o.impr?o.spend/o.impr*1000:0,
          roas:o.spend?o.val/o.spend:0, cpa:o.pur?o.spend/o.pur:0, custo_cart:o.cart?o.spend/o.cart:0,
          custo_chk:o.chk?o.spend/o.chk:0, custo_lpv:o.lpv?o.spend/o.lpv:0 };
      });
      if(!ents0.length) return null;
      return { entidades:ents0, melhores:[], metas:{}, media:{}, cancelados:{count:0,valor:0}, custos_trafego:{}, margem_op:{} };
    }catch(e){ return null; }
  }
  /* margem/cancelados (só pedidos, leve) → corrige o SALDO nos períodos derivados */
  function fetchMargem_(rng, seq){
    call({resource:"ads_margem",range:rng}).then(function(m){
      if(seq!==loadSeq || !m || m.error) return;
      if(m.cancelados) cancelados=m.cancelados;
      if(m.margem_op) margemOp=m.margem_op;
      if(m.custos_trafego) custosTrafico=m.custos_trafego;
      try{ renderKpis(curEnts()); }catch(e){}
    }).catch(function(){});
  }
  /* deriva seleção de conjunto/anúncio do diário POR ANÚNCIO (evita ads_deep pesado em período longo) */
  function deepFromDailyAd_(rng, sel){
    try{
      var dd=_adDailyMem; if(!dd||!dd.rows) return null;
      var win=acqRangeISO_(rng);
      var camps=sel.camp_ids?sel.camp_ids.split(',').filter(Boolean):null;
      var asets=sel.adset_ids?sel.adset_ids.split(',').filter(Boolean):null;
      var adis=sel.ad_ids?sel.ad_ids.split(',').filter(Boolean):null;
      var byA={};
      dd.rows.forEach(function(r){ if(r.d<win.a||r.d>win.b) return;
        if(adis && adis.indexOf(r.a)<0) return;
        if(asets && asets.indexOf(r.as)<0) return;
        if(camps && camps.indexOf(r.c)<0) return;
        var o=byA[r.a]||(byA[r.a]={as:r.as,c:r.c,spend:0,impr:0,clk:0,cart:0,chk:0,pur:0,val:0,lpv:0});
        o.spend+=r.s||0;o.impr+=r.im||0;o.clk+=r.ck||0;o.cart+=r.ca||0;o.chk+=r.ch||0;o.pur+=r.pu||0;o.val+=r.vl||0;o.lpv+=r.lp||0;
      });
      var meta={}; (dd.ads||[]).forEach(function(m){ meta[m.id]=m; });
      var ents0=Object.keys(byA).map(function(aid){ var o=byA[aid], m=meta[aid]||{};
        return { id:aid, nome:m.nome||aid, campanha:'', conjunto:'', campaign_id:o.c, adset_id:o.as,
          spend:o.spend, reach:0, impressions:o.impr, clicks:o.clk, lpv:o.lpv, carrinho:o.cart, checkout:o.chk,
          resultados:o.pur, conversao_valor:o.val, ativo:(String(m.status||'').toLowerCase().indexOf('ativ')>=0),
          ctr:o.impr?o.clk/o.impr:0, cpc:o.clk?o.spend/o.clk:0, cpm:o.impr?o.spend/o.impr*1000:0,
          roas:o.spend?o.val/o.spend:0, cpa:o.pur?o.spend/o.pur:0, custo_cart:o.cart?o.spend/o.cart:0,
          custo_chk:o.chk?o.spend/o.chk:0, custo_lpv:o.lpv?o.spend/o.lpv:0 };
      });
      if(!ents0.length) return null;
      return { entidades:ents0, melhores:[], metas:{}, media:{}, cancelados:{count:0,valor:0}, custos_trafego:{}, margem_op:{} };
    }catch(e){ return null; }
  }
  /* drill (campanha→conjuntos, conjunto→anúncios) derivado do diário por anúncio → instantâneo */
  function deriveTableFromDaily_(parent, plevel, rng){
    try{
      var dd=_adDailyMem; if(!dd||!dd.rows||!dd.rows.length) return null;
      var win=acqRangeISO_(rng), groupKey, nivel, temFilho, metaArr, parentField;
      if(plevel==='campaign'){ groupKey='as'; nivel='adset'; temFilho=true;  metaArr=dd.adsets||[]; parentField='c'; }
      else if(plevel==='adset'){ groupKey='a';  nivel='ad';    temFilho=false; metaArr=dd.ads||[];    parentField='as'; }
      else return null;
      var agg={};
      dd.rows.forEach(function(r){ if(r.d<win.a||r.d>win.b) return; if(String(r[parentField])!==String(parent)) return;
        var k=r[groupKey]; if(!k) return;
        var o=agg[k]||(agg[k]={spend:0,impr:0,clk:0,cart:0,chk:0,pur:0,val:0,lpv:0});
        o.spend+=r.s||0;o.impr+=r.im||0;o.clk+=r.ck||0;o.cart+=r.ca||0;o.chk+=r.ch||0;o.pur+=r.pu||0;o.val+=r.vl||0;o.lpv+=r.lp||0;
      });
      var meta={}; metaArr.forEach(function(m){ meta[m.id]=m; });
      var r2=function(x){return Math.round((x||0)*100)/100;}, r4=function(x){return Math.round((x||0)*10000)/10000;};
      var rows=Object.keys(agg).map(function(id){ var o=agg[id], m=meta[id]||{};
        return { id:id, nivel:nivel, nome:m.nome||id, img:'', veiculacao:m.status||'', orcamento:m.orcamento||'', utm:'', created_time:'', tem_filho:temFilho,
          valor_usado:r2(o.spend), resultados:o.pur, naopago_ded:0, custo_resultado:r2(o.pur?o.spend/o.pur:0),
          roas:r2(o.spend?o.val/o.spend:0), valor_conversao:r2(o.val),
          cpm:r2(o.impr?o.spend/o.impr*1000:0), alcance:0, cliques_link:o.clk,
          ctr_link:r4(o.impr?o.clk/o.impr:0), cpc_link:r2(o.clk?o.spend/o.clk:0),
          lpv:o.lpv, custo_lpv:r2(o.lpv?o.spend/o.lpv:0), taxa_lpv:r4(o.clk?o.lpv/o.clk:0),
          custo_cart:r2(o.cart?o.spend/o.cart:0), total_cart:o.cart,
          custo_chk:r2(o.chk?o.spend/o.chk:0), total_chk:o.chk,
          custo_compra:r2(o.pur?o.spend/o.pur:0), total_compra:o.pur, frequencia:0 };
      }).sort(function(a,b){ return b.valor_usado-a.valor_usado; });
      if(!rows.length) return null;
      return { level:nivel, rows:rows };
    }catch(e){ return null; }
  }
  function load(){
    var myseq=++loadSeq;
    acqSetLoading(true);
    var s2=selParams();
    var isDefault=!s2.camp_ids&&!s2.adset_ids&&!s2.ad_ids;
    var _rng=apiRange(dateRange);
    var _campOnly = !!(s2.camp_ids && !s2.adset_ids && !s2.ad_ids);
    var _subSel   = !!(s2.adset_ids || s2.ad_ids);
    var _long     = isLongFront_(_rng) || _rng.indexOf('~')>0;
    // ── período longo/calendário, sem seleção ou só campanha: deriva do diário POR CAMPANHA ──
    if(_long && (isDefault || _campOnly)){
      var _cids = _campOnly ? s2.camp_ids : '';
      var dced=deepFromDaily_(_rng, _cids);
      if(dced){ applyAdsData(dced); acqSetLoading(false); fetchMargem_(_rng, myseq); return; }
      call({resource:"ads_daily",objective:obj,days:400}).then(function(dd){
        if(myseq!==loadSeq) return;
        if(dd&&!dd.error){ try{ localStorage.setItem('mc_adsdaily_'+obj,JSON.stringify({ts:Date.now(),d:dd})); }catch(e){}
          var d2=deepFromDaily_(_rng, _cids); if(d2){ applyAdsData(d2); fetchMargem_(_rng, myseq); return; } }
        acqSetLoading(false); $("#adp-best").innerHTML='<p class="mc-empty">Sem dados no período</p>';
      }).catch(function(){ if(myseq!==loadSeq) return; acqSetLoading(false); });
      return;
    }
    // ── período longo/calendário, seleção de conjunto/anúncio: usa o diário POR ANÚNCIO se houver
    //    (instantâneo); senão, CAI NO FLUXO NORMAL abaixo — ads_deep filtrado pela seleção é leve. ──
    if(_long && _subSel){
      var da=deepFromDailyAd_(_rng, s2);
      if(da){ applyAdsData(da); acqSetLoading(false); fetchMargem_(_rng, myseq); return; }
      // sem diário por anúncio: baixa em 2º plano (auto-corrige nas próximas) e segue no fluxo normal
      if(!_adDailyFetching){ _adDailyFetching=true;
        call({resource:"ads_daily",objective:obj,level:'ad',days:200}).then(function(dd){ _adDailyFetching=false;
          if(dd&&!dd.error){ saveAdDaily(dd);
            if(loadSeq===myseq){ var d3=deepFromDailyAd_(_rng, s2); if(d3){ applyAdsData(d3); acqSetLoading(false); fetchMargem_(_rng, myseq); } } }
        }).catch(function(){ _adDailyFetching=false; });
      }
      // segue para o ads_deep normal (filtrado = rápido) como fallback imediato
    }
    var defKey='mc_ads_'+obj+'_'+_rng;               // base (sem seleção)
    var lsKey=isDefault?defKey:null;                 // só a base é armazenada
    if(viewMode==='funil'||viewMode==='eventos') renderFunnelPlaceholder();
    // stale-while-revalidate: se TEM cache (mesmo velho), mostra na hora e revalida ao fundo — sem "carregando"
    var _usedCache=false;
    if(isDefault){
      try{ var s=localStorage.getItem(defKey); if(s){ var _cj=JSON.parse(s); if(_cj&&_cj.d){ applyAdsData(_cj.d); _usedCache=true; } } }catch(e){}
    } else {
      // seleção: deriva instantaneamente da base baixada (KPIs/chips/funil), depois revalida ao vivo
      try{ var sd=localStorage.getItem(defKey); if(sd){ var _dj=JSON.parse(sd); if(_dj&&_dj.d){ applyAdsData(deriveSelDeep_(_dj.d, s2)); _usedCache=true; } } }catch(e){}
    }
    if(!_usedCache){ $("#adp-best").innerHTML='<p class="mc-empty">Carregando...</p>'; }
    // período JÁ FINALIZADO (passado) com cache válido: não re-busca — é instantâneo
    if(_usedCache && _rangeFresh(lsKey,_rng) && !_rangeIncludesToday(_rng)){ acqSetLoading(false); schedulePrefetch(); return; }
    call({resource:"ads_deep",objective:obj,camp_ids:s2.camp_ids,adset_ids:s2.adset_ids,ad_ids:s2.ad_ids,range:apiRange(dateRange)}).then(function(d){
      if(myseq!==loadSeq) return; // resposta antiga: descarta para não sobrescrever a data atual
      if(d&&d.error){ $("#adp-best").innerHTML='<p class="mc-empty">Erro: '+esc(d.error)+'</p>'; acqSetLoading(false); return; }
      if(lsKey) try{ localStorage.setItem(lsKey,JSON.stringify({ts:Date.now(),d:d})); }catch(e){}
      applyAdsData(d);
      schedulePrefetch();
    }).catch(function(e){ if(myseq!==loadSeq) return; acqSetLoading(false); if(!ents.length) $("#adp-best").innerHTML='<p class="mc-empty">Erro: '+esc(e.message)+'</p>'; });
  }
  /* ── prefetch: depois de carregar a opção atual, carrega as OUTRAS variações de
     objetivo ao fundo e guarda no cache, pra troca instantânea. ── */
  var _pfT;
  function schedulePrefetch(){ clearTimeout(_pfT); _pfT=setTimeout(function(){ prefetch30d(); prefetchVariations(); },1200); }
  /* prefetch dos últimos 30 dias (KPIs/deep + lista de campanhas) em segundo plano,
     pra que abrir/alternar para 30 dias seja instantâneo mesmo com outro período selecionado */
  function prefetch30d(){
    if(selCount()>0) return;                 // só no modo padrão
    if(apiRange(dateRange)==='30d') return;   // já é o período atual
    var keyD='mc_ads_'+obj+'_30d', keyT='mc_adtbl_'+obj+'_30d__';
    if(!_freshLS(keyD)) call({resource:"ads_deep",objective:obj,range:'30d'}).then(function(d){ if(d&&!d.error){ try{ localStorage.setItem(keyD,JSON.stringify({ts:Date.now(),d:d})); }catch(e){} } }).catch(function(){});
    if(!_freshLS(keyT)) call({resource:"ads_rows",objective:obj,range:'30d'}).then(function(d){ if(d&&!d.error){ try{ localStorage.setItem(keyT,JSON.stringify({ts:Date.now(),d:d})); }catch(e){} } }).catch(function(){});
  }
  function _freshLS(key){ try{ var s=localStorage.getItem(key); if(s){ var j=JSON.parse(s); return j&&(Date.now()-(j.ts||0)<240000); } }catch(e){} return false; }
  /* períodos que já terminaram (não incluem hoje) não mudam mais → cache vale 30 dias;
     períodos que incluem hoje mudam ao longo do dia → cache curto (4 min) */
  function _rangeIncludesToday(r){
    r=String(r||'');
    if(r.indexOf('~')>0){ var p=r.split('~'); var t=new Date(); t.setHours(0,0,0,0); var end=new Date(p[1]+'T00:00:00'); return end.getTime()>=t.getTime(); }
    return true; // atalhos (hoje/7d/30d/ano/max...) terminam hoje
  }
  function _rangeFresh(key,range){ try{ var s=localStorage.getItem(key); if(!s) return false; var j=JSON.parse(s); if(!j||!j.ts) return false;
    var ttl=_rangeIncludesToday(range)?240000:2592000000; return (Date.now()-j.ts)<ttl; }catch(e){} return false; }
  function prefetchVariations(){
    if(selCount()>0) return; // só no modo padrão (sem seleção manual de campanhas)
    var objs=['all','sales','traffic','engagement','leads','awareness'];
    var rng=apiRange(dateRange), i=0;
    (function next(){
      if(i>=objs.length) return;
      var o=objs[i++];
      if(o===obj){ setTimeout(next,30); return; }
      var keyD='mc_ads_'+o+'_'+rng, keyT='mc_adtbl_'+o+'_'+rng+'__';
      var jobs=[];
      if(!_freshLS(keyD)) jobs.push(call({resource:"ads_deep",objective:o,range:rng}).then(function(d){ if(d&&!d.error){ try{ localStorage.setItem(keyD,JSON.stringify({ts:Date.now(),d:d})); }catch(e){} } }).catch(function(){}));
      if(!_freshLS(keyT)) jobs.push(call({resource:"ads_rows",objective:o,range:rng}).then(function(d){ if(d&&!d.error){ try{ localStorage.setItem(keyT,JSON.stringify({ts:Date.now(),d:d})); }catch(e){} } }).catch(function(){}));
      Promise.all(jobs).then(function(){ setTimeout(next,400); });
    })();
  }
  function reloadTable(){ renderTblBc(); loadCurrentLevel(); }
  function reboot(){ sel={campaign:{},adset:{},ad:{}}; updateSelInfo(); _adDailyMem=null; loadAdDailyMem(); loadTableRoot(); load(); }
  $("#adp-obj").addEventListener("change",function(){ obj=this.value; reboot(); });

  /* ── dropdown personalizado (estilo "comparativo" da pág. de produto): esconde o
     <select> nativo e monta uma UI própria sincronizada com ele ── */
  function enhanceSelect(sel, icoSvg){
    if(!sel||sel.__mcdd) return; sel.__mcdd=1;
    sel.style.display="none";
    var caret='<span class="mc-dd-caret"><svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg></span>';
    var icoHtml=icoSvg?('<span class="mc-dd-ic">'+icoSvg+'</span>'):'';
    // suporta <optgroup> → cabeçalho de grupo (Funis / Métricas)
    var listHtml='';
    Array.prototype.forEach.call(sel.children,function(node){
      if(node.tagName==='OPTGROUP'){ listHtml+='<div class="mc-dd-grp">'+esc(node.label)+'</div>';
        Array.prototype.forEach.call(node.children,function(o){ listHtml+='<button type="button" class="mc-dd-opt" data-v="'+esc(o.value)+'">'+esc(o.text)+'</button>'; }); }
      else if(node.tagName==='OPTION'){ listHtml+='<button type="button" class="mc-dd-opt" data-v="'+esc(node.value)+'">'+esc(node.text)+'</button>'; }
    });
    var dd=document.createElement("div"); dd.className="mc-dd";
    dd.innerHTML='<button type="button" class="mc-dd-btn">'+icoHtml+'<span class="mc-dd-lbl"></span>'+caret+'</button>'+
      '<div class="mc-dd-list">'+listHtml+'</div>';
    var btn=dd.querySelector(".mc-dd-btn"), lbl=dd.querySelector(".mc-dd-lbl"), list=dd.querySelector(".mc-dd-list");
    function sync(){ var o=sel.options[sel.selectedIndex]; lbl.textContent=o?o.text:""; Array.prototype.forEach.call(list.children,function(b){ b.classList.toggle("sel",b.getAttribute("data-v")===sel.value); }); }
    sync();
    btn.addEventListener("click",function(e){ e.stopPropagation(); dd.classList.toggle("open"); });
    list.addEventListener("click",function(e){ var b=e.target.closest(".mc-dd-opt"); if(!b) return; if(sel.value!==b.getAttribute("data-v")){ sel.value=b.getAttribute("data-v"); sync(); sel.dispatchEvent(new Event("change",{bubbles:true})); } else sync(); dd.classList.remove("open"); });
    document.addEventListener("click",function(ev){ if(!dd.contains(ev.target)) dd.classList.remove("open"); });
    sel.parentNode.insertBefore(dd, sel.nextSibling);
  }
  enhanceSelect($("#adp-obj"), '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 11l18-5v12L3 14v-3z"></path><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"></path></svg>');
  /* (gráfico de barras removido — sempre linha) */
  /* dropdown "Visualização" aninhado: Conversão / Carrinho|Checkout|Aquisição (com sub custo/%/total) / Ticket */
  (function(){
    var sel=$("#adp-view"); if(!sel) return; sel.style.display="none";
    var caret='<span class="mc-dd-caret"><svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg></span>';
    var expIco='<svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';
    var GROUPS=[
      {type:'item', v:'funil', lbl:'Conversão'},
      {type:'item', v:'ctr', lbl:'CTR'},
      {type:'metric', base:'cart', lbl:'Carrinho'},
      {type:'metric', base:'chk',  lbl:'Checkout'},
      {type:'metric', base:'aq',   lbl:'Aquisição'},
      {type:'item', v:'ticket', lbl:'Ticket médio'}
    ];
    var SUBS=[['custo','Custo'],['pct','Porcentagem'],['total','Total']];
    var dd=document.createElement("div"); dd.className="mc-dd"; dd.id="adp-view-dd";
    dd.innerHTML='<button type="button" class="mc-dd-btn"><span class="mc-dd-lbl"></span>'+caret+'</button><div class="mc-dd-list"></div>';
    var btn=dd.querySelector(".mc-dd-btn"), lbl=dd.querySelector(".mc-dd-lbl"), list=dd.querySelector(".mc-dd-list");
    function curLbl(){ if(viewMode==='funil') return 'Conversão'; var m=SERIES_META[viewMode]; return m?m.lbl:'Visualização'; }
    function renderList(){
      var h='';
      GROUPS.forEach(function(g,gi){
        if(gi===0) h+='<div class="mc-dd-grp">Funil</div>';
        if(gi===1) h+='<div class="mc-dd-grp">Métricas</div>';
        if(g.type==='item'){ h+='<button type="button" class="mc-dd-opt'+(viewMode===g.v?' sel':'')+'" data-v="'+g.v+'">'+esc(g.lbl)+'</button>'; }
        else {
          var open=(viewMode.indexOf(g.base+'_')===0);
          h+='<button type="button" class="mc-dd-opt mc-vd-head'+(open?' open':'')+'" data-base="'+g.base+'"><span>'+esc(g.lbl)+'</span><span class="mc-vd-exp-ic">'+expIco+'</span></button>'+
             '<div class="mc-vd-subs'+(open?' open':'')+'" data-subs="'+g.base+'">'+
             SUBS.map(function(su){ var vv=g.base+'_'+su[0]; return '<button type="button" class="mc-dd-opt mc-vd-sub'+(viewMode===vv?' sel':'')+'" data-v="'+vv+'">'+esc(su[1])+'</button>'; }).join('')+'</div>';
        }
      });
      list.innerHTML=h;
    }
    function apply(v){ viewMode=v; sel.value=v; lbl.textContent=curLbl(); cmpSync(); renderCurrentView(); dd.classList.remove("open"); }
    btn.addEventListener("click",function(e){ e.stopPropagation(); dd.classList.toggle("open"); if(dd.classList.contains("open")) renderList(); });
    list.addEventListener("click",function(e){
      // clicar na métrica abre suas 3 opções (accordion: fecha as outras); clicar num sub aplica
      var head=e.target.closest(".mc-vd-head");
      if(head){ e.stopPropagation(); var base=head.getAttribute("data-base");
        var subs=list.querySelector('.mc-vd-subs[data-subs="'+base+'"]'), willOpen=subs&&!subs.classList.contains("open");
        Array.prototype.forEach.call(list.querySelectorAll(".mc-vd-subs"),function(s){ s.classList.remove("open"); });
        Array.prototype.forEach.call(list.querySelectorAll(".mc-vd-head"),function(hd){ hd.classList.remove("open"); });
        if(willOpen){ subs.classList.add("open"); head.classList.add("open"); }
        return;
      }
      var opt=e.target.closest(".mc-dd-opt"); if(!opt||opt.classList.contains("mc-vd-head")) return; var v=opt.getAttribute("data-v"); if(v) apply(v);
    });
    document.addEventListener("click",function(ev){ if(!dd.contains(ev.target)) dd.classList.remove("open"); });
    lbl.textContent=curLbl();
    sel.parentNode.insertBefore(dd, sel.nextSibling);
  })();
  /* dropdown "Comparar" (multi-seleção) — sobrepõe linhas de outras métricas no gráfico.
     Só aparece quando a visualização não é o funil; lista todas as métricas exceto a primária. */
  (function(){
    var wrap=$("#adp-view-tools"); if(!wrap) return;
    var caret='<span class="mc-dd-caret"><svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg></span>';
    var exp='<span class="mc-vd-exp-ic"><svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg></span>';
    var CG=[{item:'ctr',lbl:'CTR'},{base:'cart',lbl:'Carrinho'},{base:'chk',lbl:'Checkout'},{base:'aq',lbl:'Aquisição'}];
    var SUBS=[['custo','Custo'],['pct','Porcentagem'],['total','Total']];
    var dd=document.createElement("div"); dd.className="mc-dd"; dd.id="adp-cmp-dd"; dd.style.display="none";
    dd.innerHTML='<button type="button" class="mc-dd-btn"><span class="mc-dd-lbl">Comparar</span>'+caret+'</button><div class="mc-dd-list"></div>';
    wrap.insertBefore(dd, $("#adp-view"));   // depois dos ícones de gráfico, antes da Visualização
    var btn=dd.querySelector(".mc-dd-btn"), lbl=dd.querySelector(".mc-dd-lbl"), list=dd.querySelector(".mc-dd-list");
    /* mesma UI do dropdown principal (botões .mc-dd-opt, sem checkbox); multi-seleção via classe .sel */
    function renderList(){
      var h='';
      CG.forEach(function(g){
        if(g.item){ if(g.item===viewMode) return; h+='<button type="button" class="mc-dd-opt'+(cmpMetrics.indexOf(g.item)>=0?' sel':'')+'" data-v="'+g.item+'">'+esc(g.lbl)+'</button>'; return; }
        var subs=SUBS.map(function(su){ return g.base+'_'+su[0]; }).filter(function(v){ return v!==viewMode; });
        if(!subs.length) return;
        var open=subs.some(function(v){ return cmpMetrics.indexOf(v)>=0; });
        h+='<button type="button" class="mc-dd-opt mc-vd-head'+(open?' open':'')+'" data-base="'+g.base+'"><span>'+esc(g.lbl)+'</span>'+exp+'</button>'+
           '<div class="mc-vd-subs'+(open?' open':'')+'" data-subs="'+g.base+'">'+
           SUBS.map(function(su){ var vv=g.base+'_'+su[0]; if(vv===viewMode) return ''; return '<button type="button" class="mc-dd-opt mc-vd-sub'+(cmpMetrics.indexOf(vv)>=0?' sel':'')+'" data-v="'+vv+'">'+esc(su[1])+'</button>'; }).join('')+
           '</div>';
      });
      list.innerHTML=h;
    }
    function updLbl(){ lbl.textContent=cmpMetrics.length?('Comparar ('+cmpMetrics.length+')'):'Comparar'; }
    btn.addEventListener("click",function(e){ e.stopPropagation(); dd.classList.toggle("open"); if(dd.classList.contains("open")) renderList(); });
    list.addEventListener("click",function(e){
      // cabeçalho de métrica: abre/fecha o accordion (fecha os demais)
      var head=e.target.closest(".mc-vd-head");
      if(head){ var base=head.getAttribute("data-base"), subs=list.querySelector('.mc-vd-subs[data-subs="'+base+'"]'), willOpen=subs&&!subs.classList.contains("open");
        Array.prototype.forEach.call(list.querySelectorAll(".mc-vd-subs"),function(s){ s.classList.remove("open"); });
        Array.prototype.forEach.call(list.querySelectorAll(".mc-vd-head"),function(hd){ hd.classList.remove("open"); });
        if(willOpen){ subs.classList.add("open"); head.classList.add("open"); }
        return; }
      // opção: alterna a métrica na comparação (multi-seleção)
      var opt=e.target.closest(".mc-dd-opt"); if(!opt||opt.classList.contains("mc-vd-head")) return;
      var k=opt.getAttribute("data-v"); if(!k) return;
      var idx=cmpMetrics.indexOf(k);
      if(idx>=0) cmpMetrics.splice(idx,1); else cmpMetrics.push(k);
      opt.classList.toggle("sel");
      updLbl(); if(viewMode!=="funil") renderSeries();
    });
    cmpSync=function(){
      if(viewMode==="funil"||viewMode==="eventos"){ dd.style.display="none"; cmpMetrics=[]; }
      else { dd.style.display=""; cmpMetrics=cmpMetrics.filter(function(k){ return k!==viewMode; }); }
      updLbl(); renderList();
    };
  })();
  /* ── limpeza de cache + indicador de uso (roda ao carregar) ── */
  (function(){
    try{
      var now=Date.now(), rm=[];
      for(var i=0;i<localStorage.length;i++){ var k=localStorage.key(i); if(!k||k.indexOf('mc_')!==0) continue;
        // caches de período personalizado (contêm ~) são efêmeros → remove os com +1h
        if(k.indexOf('~')>=0){ var velho=true; try{ var j=JSON.parse(localStorage.getItem(k)); if(j&&j.ts&&now-j.ts<3600000) velho=false; }catch(e){} if(velho) rm.push(k); }
      }
      rm.forEach(function(k){ try{ localStorage.removeItem(k); }catch(e){} });
    }catch(e){}
  })();
  /* ── botão "Baixar dados": baixa tudo que a página usa (lista de campanhas, KPIs e
     análise de métricas) de hoje até os últimos 30 dias e guarda no cache; ao trocar
     o período, a página usa esse cache e atualiza tudo automaticamente. ── */
  (function(){
    var btn=$("#adp-download"); if(!btn) return;
    var dlIcon='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>';
    var okIcon='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
    function lsSet(k,d){ try{ localStorage.setItem(k,JSON.stringify({ts:Date.now(),d:d})); }catch(e){} }
    var DL_FRESH=20*60*1000;  // dado baixado nos últimos 20 min é considerado atual → não rebaixa
    function dlFresh(key){ try{ var s=localStorage.getItem(key); if(!s) return false; var j=JSON.parse(s); return j&&(Date.now()-(j.ts||0)<DL_FRESH); }catch(e){ return false; } }
    function isoDay(d){ return d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+('0'+d.getDate()).slice(-2); }
    btn.addEventListener("click",function(){
      if(btn.disabled) return;
      var ranges=['hoje','hoje_ontem','7d','30d'];

      // ── dataset diário (6 meses) INCREMENTAL: baixa só os dias que faltam e mescla ──
      (function(){
        var key='mc_adsdaily_'+obj, prev=null;
        try{ var s=localStorage.getItem(key); if(s) prev=JSON.parse(s); }catch(e){}
        if(prev && Date.now()-(prev.ts||0)<DL_FRESH) return;   // já recente → nem baixa
        var days=400;   // cobre ano/máximo com folga (o backend limita em 400)
        if(prev && prev.d && prev.d.until){
          var last=new Date(prev.d.until+'T00:00:00'), now=new Date(); now.setHours(0,0,0,0);
          var diff=Math.round((now-last)/864e5); if(diff>=0) days=Math.max(2, Math.min(400, diff+1)); // só os dias novos (+ hoje)
        }
        call({resource:"ads_daily",objective:obj,days:days}).then(function(d){
          if(!d||d.error) return; var merged=d;
          if(prev && prev.d && prev.d.rows && days<400){       // mescla o antigo com os dias novos
            var map={}; prev.d.rows.forEach(function(r){ map[r.c+'|'+r.d]=r; }); d.rows.forEach(function(r){ map[r.c+'|'+r.d]=r; });
            merged={ since:prev.d.since, until:d.until, campaigns:(d.campaigns&&d.campaigns.length)?d.campaigns:prev.d.campaigns, rows:Object.keys(map).map(function(k){return map[k];}) };
          }
          lsSet(key, merged);
          if(viewMode!=='funil'&&viewMode!=='eventos'){ seriesData=null; seriesKey=''; loadSeries(); }
        }).catch(function(){});
      })();

      // ── diário POR ANÚNCIO (2º plano) → seleções/drill de conjunto/anúncio offline ──
      (function(){
        var keyA='mc_adsdailyad_'+obj;
        if(dlFresh(keyA)) return;
        call({resource:"ads_daily",objective:obj,level:'ad',days:200}).then(function(d){ if(d&&!d.error){ saveAdDaily(d); } }).catch(function(){});
      })();

      // ── monta só o que falta (pula o que já está recente no cache) ──
      var jobs=[], needLevel=false;
      ranges.forEach(function(rng){
        var kD='mc_ads_'+obj+'_'+rng, kR='mc_adtbl_'+obj+'_'+rng+'__', kS='mc_adseries_v5_'+obj+'_'+rng,
            kAs='mc_adlvl_adset_'+rng+'__', kAd='mc_adlvl_ad_'+rng+'__';
        if(!dlFresh(kD)) jobs.push(function(){ return call({resource:"ads_deep",objective:obj,range:rng}).then(function(d){ if(d&&!d.error) lsSet(kD, d); }); });
        if(!dlFresh(kR)) jobs.push(function(){ return call({resource:"ads_rows",objective:obj,range:rng}).then(function(d){ if(d&&!d.error) lsSet(kR, d); }); });
        if(!dlFresh(kS)) jobs.push(function(){ return call({resource:"ads_series",objective:obj,camp_ids:'',adset_ids:'',ad_ids:'',range:rng}).then(function(d){ if(d&&!d.error) lsSet(kS, d); }); });
        if(rng!=='30d'){
          if(!dlFresh(kAs)){ needLevel=true; jobs.push(function(){ return call({resource:"ads_level",level:'adset',range:rng}).then(function(d){ if(d&&!d.error) lsSet(kAs, d); }); }); }
          if(!dlFresh(kAd)){ needLevel=true; jobs.push(function(){ return call({resource:"ads_level",level:'ad',range:rng}).then(function(d){ if(d&&!d.error) lsSet(kAd, d); }); }); }
        }
      });
      // aquece as entidades (criativos 1×) só se algum conjunto/anúncio precisa ser baixado
      var warm=[];
      var need30As=!dlFresh('mc_adlvl_adset_30d__'), need30Ad=!dlFresh('mc_adlvl_ad_30d__');
      if(need30As||need30Ad||needLevel){
        warm.push(function(){ return call({resource:"ads_level",level:'adset',range:'30d'}).then(function(d){ if(d&&!d.error) lsSet('mc_adlvl_adset_30d__', d); }); });
        warm.push(function(){ return call({resource:"ads_level",level:'ad',range:'30d'}).then(function(d){ if(d&&!d.error) lsSet('mc_adlvl_ad_30d__', d); }); });
      }

      var total=warm.length+jobs.length;
      if(!total){ btn.innerHTML=okIcon+'<span>Já atualizado</span>'; setTimeout(function(){ btn.innerHTML=dlIcon+'<span>Baixar dados</span>'; },2000); return; }
      var done=0; btn.disabled=true; btn.innerHTML='<span>Baixando 0%</span>';
      function tick(){ done++; btn.innerHTML='<span>Baixando '+Math.round(done/total*100)+'%</span>'; }
      Promise.all(warm.map(function(j){ return j().catch(function(){}).then(tick); })).then(function(){
        var idx=0, POOL=Math.min(6,jobs.length);
        function runNext(){ if(idx>=jobs.length) return Promise.resolve(); var job=jobs[idx++]; return job().catch(function(){}).then(function(){ tick(); return runNext(); }); }
        var workers=[]; for(var w=0; w<POOL; w++) workers.push(runNext());
        return Promise.all(workers);
      }).then(function(){
        btn.innerHTML=okIcon+'<span>Dados baixados</span>';
        setTimeout(function(){ btn.disabled=false; btn.innerHTML=dlIcon+'<span>Baixar dados</span>'; },2500);
        seriesData=null; seriesKey=''; load(); reloadTable();
      });
    });
  })();

  /* periodo */
  function applyCustomRange(){
    if(!fp||fp.selectedDates.length<2) return;
    var s=fp.formatDate(fp.selectedDates[0],"Y-m-d"),e=fp.formatDate(fp.selectedDates[1],"Y-m-d");
    var label=fp.formatDate(fp.selectedDates[0],"d/m")+" - "+fp.formatDate(fp.selectedDates[1],"d/m");
    setRange(s+"~"+e, label);
  }
  try{ if(typeof flatpickr!=="undefined") fp=flatpickr("#adp-date-input",{mode:"range",locale:"pt",dateFormat:"Y-m-d",maxDate:new Date(),static:false,onChange:function(sel){ if(sel.length===2) applyCustomRange(); }}); }catch(e){fp=null;}

  /* Position flatpickr calendar aligned to the right edge of a reference element */
  function openCal(refEl){
    if(!fp){ alert("Calendario nao carregou."); return; }
    fp.open();
    // Reposition after the calendar appears in the DOM
    requestAnimationFrame(function(){
      var cal=document.querySelector(".flatpickr-calendar");
      if(!cal||!refEl) return;
      var rect=refEl.getBoundingClientRect();
      var calW=cal.offsetWidth||308;
      var left=rect.right-calW;
      var top=rect.bottom+4;
      // keep within viewport
      if(left<4) left=4;
      cal.style.position="fixed";
      cal.style.top=top+"px";
      cal.style.left=left+"px";
      cal.style.right="auto";
    });
  }

  function setOpt(el){ Array.prototype.forEach.call($("#adp-range-opts").querySelectorAll("button"),function(x){x.classList.remove("is-active");}); if(el&&el.id!=="adp-custom") el.classList.add("is-active"); }
  function setTopOpt(el){ Array.prototype.forEach.call(root.querySelectorAll("#adp-top-range-opts button"),function(x){x.classList.remove("is-active");}); if(el&&el.id!=="adp-top-custom") el.classList.add("is-active"); }
  function syncRangeLabel(txt){ var l=root.querySelector("#adp-top-range-label"); if(l) l.textContent=txt; }
  /* marca o botão ativo nos DOIS seletores (topo + tabela). r=null para personalizado */
  function markActive(r){
    Array.prototype.forEach.call(root.querySelectorAll("#adp-range-opts button[data-range],#adp-top-range-opts button[data-range]"),function(x){
      var dr=x.getAttribute("data-range");
      if(dr&&dr===r) x.classList.add("is-active"); else x.classList.remove("is-active");
    });
  }
  /* ponto único de troca de período: sincroniza ambos seletores e recarrega */
  function setRange(r,label){
    dateRange=r;
    var _rl=$("#adp-range-label"); if(_rl) _rl.textContent=label; syncRangeLabel(label);
    markActive((r&&r.indexOf("~")<0)?r:null);
    var _rp=$("#adp-rangepicker"); if(_rp) _rp.classList.remove("open");
    if(typeof topRp!=="undefined"&&topRp) topRp.classList.remove("open");
    try{ localStorage.setItem('mc_adp_range',JSON.stringify({r:r,label:label})); }catch(e){}
    load(); reloadTable();
  }
  /* ===== Calendário de período (mesmo design da página de produto) ===== */
  var ACQ_MONTHS=["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];
  var ACQ_PRESET_LABEL={hoje:'Hoje',hoje_ontem:'Hoje+Ontem','7d':'7 dias','30d':'30 dias','6m':'6 meses',ano:'Ano',max:'Máximo'};
  /* se o intervalo do calendário coincide com um atalho, retorna a chave dele (reaproveita cache) */
  function acqPresetKey(a,b){
    var t=new Date(); t.setHours(0,0,0,0);
    function iso(d){ return d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+('0'+d.getDate()).slice(-2); }
    var ea=iso(a), eb=iso(b), et=iso(t);
    if(ea===et&&eb===et) return 'hoje';
    if(ea===iso(new Date(t.getTime()-864e5))&&eb===et) return 'hoje_ontem';
    if(ea===iso(new Date(t.getTime()-6*864e5))&&eb===et) return '7d';
    if(ea===iso(new Date(t.getTime()-29*864e5))&&eb===et) return '30d';
    if(ea===iso(new Date(t.getFullYear(),0,1))&&eb===et) return 'ano';
    return null;
  }
  function acqIso(d){ return d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+('0'+d.getDate()).slice(-2); }
  function acqBR(d){ return ('0'+d.getDate()).slice(-2)+'/'+('0'+(d.getMonth()+1)).slice(-2); }
  function acqSame(a,b){ return a&&b&&a.getFullYear()===b.getFullYear()&&a.getMonth()===b.getMonth()&&a.getDate()===b.getDate(); }
  function acqCal(container, toggle){
    if(!container||!toggle) return;
    var st={view:null,start:null,end:null,open:false,grid:null,title:null,rng:null};
    var today=new Date(); today.setHours(0,0,0,0);
    st.end=today; st.start=new Date(today.getTime()-29*864e5); st.view=new Date(today.getFullYear(),today.getMonth(),1);
    container.style.cssText="position:absolute;top:calc(100% + 6px);right:0;z-index:60;display:none;background:#0f0f0f;border:1px solid #2a2a2a;box-shadow:0 18px 44px rgba(0,0,0,.6);flex-direction:row";
    var presets=[['hoje','Hoje'],['hoje_ontem','Hoje+Ontem'],['7d','7 dias'],['30d','30 dias'],['6m','6 meses'],['ano','Ano'],['max','Máximo']];
    var pBtn="text-align:left;padding:7px 10px;font-size:11px;text-transform:uppercase;letter-spacing:.04em;color:#8a8a8a;background:none;border:none;cursor:pointer;border-radius:6px;font-family:inherit;white-space:nowrap";
    container.innerHTML=
      '<div style="display:flex;flex-direction:column;padding:8px;gap:2px;border-right:1px solid #1e1e1e;min-width:112px">'
        +presets.map(function(o){ return '<button type="button" data-range="'+o[0]+'" style="'+pBtn+'">'+o[1]+'</button>'; }).join('')
      +'</div>'
      +'<div style="padding:12px 14px 10px;width:262px">'
        +'<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:8px">'
          +'<button type="button" class="acq-prev" style="width:28px;height:28px;background:none;border:none;color:#8a8a8a;cursor:pointer;font-size:20px;line-height:1">‹</button>'
          +'<span class="acq-title" style="font-size:13px;font-weight:600;color:#f5f5f5"></span>'
          +'<button type="button" class="acq-next" style="width:28px;height:28px;background:none;border:none;color:#8a8a8a;cursor:pointer;font-size:20px;line-height:1">›</button>'
        +'</div>'
        +'<div style="display:grid;grid-template-columns:repeat(7,1fr);text-align:center;font-size:10px;text-transform:uppercase;color:#8a8a8a;opacity:.7;margin-bottom:4px"><span>D</span><span>S</span><span>T</span><span>Q</span><span>Q</span><span>S</span><span>S</span></div>'
        +'<div class="acq-grid" style="display:grid;grid-template-columns:repeat(7,1fr);gap:3px"></div>'
        +'<div style="display:flex;align-items:center;justify-content:space-between;margin-top:10px;padding-top:9px;border-top:1px solid #1e1e1e">'
          +'<span class="acq-rng" style="font-size:10.5px;color:#8a8a8a"></span>'
          +'<button type="button" class="acq-apply" style="padding:6px 14px;background:#fff200;color:#0a0a0a;border:none;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;cursor:pointer;font-family:inherit">Aplicar</button>'
        +'</div>'
      +'</div>';
    st.grid=container.querySelector('.acq-grid'); st.title=container.querySelector('.acq-title'); st.rng=container.querySelector('.acq-rng');
    function render(){
      var v=st.view; st.title.textContent=ACQ_MONTHS[v.getMonth()]+" "+v.getFullYear();
      var first=new Date(v.getFullYear(),v.getMonth(),1), gs=new Date(first.getTime()-first.getDay()*864e5), h="";
      var base="width:100%;height:32px;display:flex;align-items:center;justify-content:center;font-size:12px;background:none;border:none;cursor:pointer;font-family:inherit;border-radius:0;color:#f5f5f5";
      for(var i=0;i<42;i++){ var d=new Date(gs.getFullYear(),gs.getMonth(),gs.getDate()+i); var s=base;
        var outM=d.getMonth()!==v.getMonth();
        if(outM) s+=";color:#4a4a4a";                                      // fora do mês: cinza
        var isS=acqSame(d,st.start), isE=acqSame(d,st.end);
        if(st.start&&st.end&&d>=st.start&&d<=st.end&&!isS&&!isE) s+=";background:rgba(255,242,0,.16);color:"+(outM?"#a5852a":"#f5f5f5");  // do mês=branco; fora do mês=amarelo escuro
        if((isS||isE)&&st.end) s+=";background:#fff200;color:#0a0a0a;font-weight:700;border-radius:0";  // dias de borda do range: quadrado, amarelo sólido
        if(isS&&!st.end) s+=";background:#fff200;color:#0a0a0a;font-weight:700;border-radius:0";        // dia único: quadrado
        if(acqSame(d,today)&&!isS&&!isE) s+=";box-shadow:inset 0 0 0 1px #2a2a2a";
        h+='<button type="button" data-date="'+acqIso(d)+'" style="'+s+'">'+d.getDate()+'</button>';
      }
      st.grid.innerHTML=h;
      if(st.start){ var e=st.end||st.start; st.rng.textContent=acqBR(st.start)+((st.end&&!acqSame(st.start,st.end))?(' – '+acqBR(e)):''); } else st.rng.textContent="Selecione um período";
      // destaca o atalho ativo conforme o período aplicado
      Array.prototype.forEach.call(container.querySelectorAll('button[data-range]'),function(x){ x.style.color=(x.getAttribute('data-range')===dateRange)?'#fff200':'#8a8a8a'; });
    }
    /* mapeia o período aplicado (dateRange) para o intervalo mostrado no calendário */
    function syncFromRange(){
      var t=new Date(); t.setHours(0,0,0,0); var r=dateRange;
      function set(a,b){ st.start=a; st.end=b; st.view=new Date((b||a||t).getFullYear(),(b||a||t).getMonth(),1); }
      if(r==='hoje') set(t,t);
      else if(r==='hoje_ontem') set(new Date(t.getTime()-864e5),t);
      else if(r==='7d') set(new Date(t.getTime()-6*864e5),t);
      else if(r==='30d') set(new Date(t.getTime()-29*864e5),t);
      else if(r==='6m'){ var d6=new Date(t); d6.setMonth(d6.getMonth()-6); set(d6,t); }
      else if(r==='ano') set(new Date(t.getFullYear(),0,1),t);
      else if(r==='max'){ st.start=null; st.end=null; st.view=new Date(t.getFullYear(),t.getMonth(),1); }
      else if(r&&r.indexOf('~')>0){ var p=r.split('~'); set(new Date(p[0]+'T00:00:00'), new Date(p[1]+'T00:00:00')); }
      else set(new Date(t.getTime()-29*864e5),t);
    }
    function open(o){ st.open=o; container.style.display=o?'flex':'none'; calBackdrop_(o); if(o){ syncFromRange(); render(); } }
    st._open=open;
    toggle.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); acqCloseAll(container); open(!st.open); });
    container.addEventListener('click',function(e){
      e.stopPropagation();
      var pre=e.target.closest('button[data-range]');
      if(pre){ open(false); setRange(pre.getAttribute('data-range'), pre.textContent.trim()); return; }
      if(e.target.closest('.acq-prev')){ st.view=new Date(st.view.getFullYear(),st.view.getMonth()-1,1); render(); return; }
      if(e.target.closest('.acq-next')){ st.view=new Date(st.view.getFullYear(),st.view.getMonth()+1,1); render(); return; }
      if(e.target.closest('.acq-apply')){ if(!st.start) return; var en=st.end||st.start; open(false);
        var pk=acqPresetKey(st.start,en);   // se o intervalo bate com um atalho, usa a mesma chave (reaproveita cache)
        if(pk){ setRange(pk, ACQ_PRESET_LABEL[pk]); } else { setRange(acqIso(st.start)+'~'+acqIso(en), acqBR(st.start)+' - '+acqBR(en)); }
        return; }
      var day=e.target.closest('button[data-date]');
      if(day){ var p=day.getAttribute('data-date').split('-'); var d=new Date(+p[0],+p[1]-1,+p[2]);
        if(!st.start||st.end){ st.start=d; st.end=null; } else { if(d<st.start){ st.end=st.start; st.start=d; } else st.end=d; }
        render(); }
    });
    ACQ_CALS.push({container:container, close:function(){ open(false); }});
  }
  var ACQ_CALS=[];
  function acqCloseAll(except){ ACQ_CALS.forEach(function(c){ if(c.container!==except) c.close(); }); }
  acqCal($("#adp-cal"), $("#adp-range-toggle"));
  acqCal(root.querySelector("#adp-top-cal"), root.querySelector("#adp-top-range-toggle"));
  document.addEventListener("click",function(ev){
    ACQ_CALS.forEach(function(c){ if(c.container.parentNode && !c.container.parentNode.contains(ev.target)) c.close(); });
  });
  // só um dropdown aberto por vez — em CAPTURA (roda antes do stopPropagation dos botões)
  document.addEventListener("click",function(ev){
    var here=ev.target.closest(".mc-dd, .mc-colpick");
    root.querySelectorAll(".mc-dd.open, .mc-colpick.open").forEach(function(el){ if(el!==here) el.classList.remove("open"); });
    if(here){ acqCloseAll(null); }
  }, true);
  /* restaura o último período escolhido (não "volta com outro" ao recarregar) */
  (function restoreRange(){
    try{
      var saved=JSON.parse(localStorage.getItem('mc_adp_range'));
      if(saved&&saved.r){
        dateRange=saved.r;
        var lbl=saved.label||rangeLabel(saved.r);
        var _rl2=$("#adp-range-label"); if(_rl2) _rl2.textContent=lbl; syncRangeLabel(lbl);
        markActive((String(saved.r).indexOf('~')<0)?saved.r:null);
      }
    }catch(e){}
  })();
  reboot();
})();